// noinspection JSUnusedGlobalSymbols

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
    Date: any;
    /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
    DateTime: any;
    /** Can be used as an argument to upload files using https://github.com/jaydenseric/graphql-multipart-request-spec */
    Upload: any;
}

export interface AcceptInviteStudentToDrivingSchoolInput {
    drivingSchoolStudentId: Scalars['ID'];
}

export interface AcceptInviteStudentToDrivingSchoolResponse {
    status: AcceptInviteStudentToDrivingSchoolStatusEnum;
}

export enum AcceptInviteStudentToDrivingSchoolStatusEnum {
    Accepted = 'ACCEPTED',
    AlreadyAccepted = 'ALREADY_ACCEPTED',
}

export interface Address {
    city: Scalars['String'];
    createdAt: Scalars['DateTime'];
    id: Scalars['ID'];
    number: Scalars['String'];
    numberAddition?: Maybe<Scalars['String']>;
    postalCode: Scalars['String'];
    street: Scalars['String'];
    updatedAt: Scalars['DateTime'];
}

export interface AddressInput {
    city: Scalars['String'];
    number: Scalars['String'];
    numberAddition?: InputMaybe<Scalars['String']>;
    postalCode: Scalars['String'];
    street: Scalars['String'];
}

export interface AuthPayload {
    accessToken?: Maybe<Scalars['String']>;
    expiresIn?: Maybe<Scalars['Int']>;
    refreshToken?: Maybe<Scalars['String']>;
    tokenType?: Maybe<Scalars['String']>;
    user?: Maybe<User>;
}

export interface CalendarEvent {
    author: User;
    calendarEventParticipants: Array<CalendarEventParticipant>;
    description?: Maybe<Scalars['String']>;
    drivingSchool: DrivingSchool;
    endsAt: Scalars['DateTime'];
    hidden: Scalars['Boolean'];
    id: Scalars['ID'];
    location?: Maybe<Scalars['String']>;
    product?: Maybe<Product>;
    recurredFromEvent?: Maybe<CalendarEvent>;
    recurrences: Array<CalendarEvent>;
    startsAt: Scalars['DateTime'];
    status: EventStatusEnum;
    tableNumber?: Maybe<Scalars['String']>;
    title: Scalars['String'];
    type?: Maybe<CalendarEventType>;
    vehicles: Array<Vehicle>;
}

export interface CalendarEventInput {
    id: Scalars['ID'];
}

export interface CalendarEventNote extends NoteInterface {
    author: User;
    calendarEvent: CalendarEvent;
    createdAt: Scalars['DateTime'];
    id: Scalars['ID'];
    text: Scalars['String'];
    updatedAt: Scalars['DateTime'];
    visibleForStudent: Scalars['Boolean'];
}

export interface CalendarEventNotesInput {
    calendarEventId: Scalars['ID'];
}

export interface CalendarEventParticipant {
    actor: CalendarEventParticipantActor;
    calendarEvent: CalendarEvent;
    id: Scalars['ID'];
}

export type CalendarEventParticipantActor = Instructor | Student | User;

export interface CalendarEventType {
    id: Scalars['ID'];
    name: Scalars['String'];
}

export interface CalendarEventsInput {
    dateFrom: Scalars['DateTime'];
    dateTo: Scalars['DateTime'];
    drivingSchoolId?: InputMaybe<Scalars['ID']>;
    includeHidden?: InputMaybe<Scalars['Boolean']>;
    instructorId?: InputMaybe<Scalars['ID']>;
    studentId?: InputMaybe<Scalars['ID']>;
    userId?: InputMaybe<Scalars['ID']>;
    vehicleId?: InputMaybe<Scalars['ID']>;
}

export interface Chapter {
    id: Scalars['ID'];
    paragraphs: Array<Paragraph>;
    title: Scalars['String'];
}

export interface ConnectStudentToDrivingSchoolInput {
    connectCode: Scalars['Int'];
    id: Scalars['ID'];
}

export interface ConnectStudentToDrivingSchoolResponse {
    status: ConnectStudentToDrivingSchoolStatusEnum;
}

export enum ConnectStudentToDrivingSchoolStatusEnum {
    AlreadyConnected = 'ALREADY_CONNECTED',
    Connected = 'CONNECTED',
}

export interface Contact {
    createdAt: Scalars['DateTime'];
    email: Scalars['String'];
    firstName: Scalars['String'];
    id: Scalars['ID'];
    lastName: Scalars['String'];
    phone?: Maybe<Scalars['String']>;
    updatedAt: Scalars['DateTime'];
}

export type Content = Image | Text | Video;

export interface CourseProduct extends PlannableProductInterface, ProductInterface {
    color: Scalars['String'];
    defaultDurationInMinutes: Scalars['Int'];
    drivingSchool: DrivingSchool;
    educationCategory: EducationCategory;
    id: Scalars['ID'];
    priceExcludingVat: Scalars['String'];
    title: Scalars['String'];
    type: ProductTypeEnum;
    vatPercentage: VatPercentage;
}

export interface CreateCalendarEventInput {
    calendarEventTypeId?: InputMaybe<Scalars['ID']>;
    description?: InputMaybe<Scalars['String']>;
    drivingSchoolId: Scalars['ID'];
    endsAt: Scalars['DateTime'];
    instructorIds?: InputMaybe<Array<Scalars['ID']>>;
    location?: InputMaybe<Scalars['String']>;
    product?: InputMaybe<ProductObjectInput>;
    startsAt: Scalars['DateTime'];
    status: EventStatusEnum;
    studentIds?: InputMaybe<Array<Scalars['ID']>>;
    tableNumber?: InputMaybe<Scalars['String']>;
    title: Scalars['String'];
    userIds?: InputMaybe<Array<Scalars['ID']>>;
    vehicleIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface CreateCalendarEventNoteInput {
    calendarEventId: Scalars['ID'];
    text: Scalars['String'];
    visibleForStudent: Scalars['Boolean'];
}

export interface CreateMileageInput {
    kilometers: Scalars['Int'];
    notes?: InputMaybe<Scalars['String']>;
    registeredAt: Scalars['DateTime'];
    vehicleId: Scalars['ID'];
}

export interface CreateRoadmapPaywallCodeInput {
    duration: RoadmapPaywallCodeDurationEnum;
    email: Scalars['String'];
    roadmapId: Scalars['ID'];
}

export interface CreateScriptNoteInput {
    roadmapProgressId: Scalars['ID'];
    scriptId: Scalars['ID'];
    text: Scalars['String'];
    visibleForStudent: Scalars['Boolean'];
}

export interface CreateScriptResultInput {
    calendarEventId: Scalars['ID'];
    contextualScriptId?: InputMaybe<Scalars['ID']>;
    rating: ScriptRatingEnum;
    roadmapProgressId: Scalars['ID'];
    scriptId: Scalars['ID'];
}

export interface CreateStudentInput {
    avatar?: InputMaybe<Scalars['Upload']>;
    birthdate?: InputMaybe<Scalars['Date']>;
    cbrId?: InputMaybe<Scalars['String']>;
    drivingSchoolId: Scalars['ID'];
    email: Scalars['String'];
    firstName: Scalars['String'];
    invoiceAddress: AddressInput;
    lastName: Scalars['String'];
    phone?: InputMaybe<Scalars['String']>;
    pickupAddress: AddressInput;
    postalAddress: AddressInput;
    preferredInstructorIds: Array<Scalars['ID']>;
}

export interface CreateStudentNoteInput {
    studentId: Scalars['ID'];
    text: Scalars['String'];
}

export interface CreateStudentResponse {
    status: CreateStudentStatusEnum;
    student?: Maybe<Student>;
}

export enum CreateStudentStatusEnum {
    AlreadyConnected = 'ALREADY_CONNECTED',
    AvailableToConnect = 'AVAILABLE_TO_CONNECT',
    Created = 'CREATED',
}

export interface CreateVehicleInput {
    brand: Scalars['String'];
    cbrId?: InputMaybe<Scalars['String']>;
    drivingSchoolId: Scalars['ID'];
    licensePlate: Scalars['String'];
    model: Scalars['String'];
    name?: InputMaybe<Scalars['String']>;
    year: Scalars['Int'];
}

export interface CreateWalletMutationInput {
    comments?: InputMaybe<Scalars['String']>;
    drivingSchoolId: Scalars['ID'];
    product: ProductObjectInput;
    quantity: Scalars['Int'];
    studentId: Scalars['ID'];
}

export enum CreditDisplayTypeEnum {
    Lessons = 'LESSONS',
    Time = 'TIME',
}

export interface DeleteCalendarEventInput {
    id: Scalars['ID'];
}

export interface DeleteCalendarEventNoteInput {
    id: Scalars['ID'];
}

export interface DeleteMileageInput {
    id: Scalars['ID'];
}

export interface DeleteScriptNoteInput {
    id: Scalars['ID'];
}

export interface DeleteStudentNoteInput {
    id: Scalars['ID'];
}

export interface DeleteVehicleInput {
    id: Scalars['ID'];
}

export interface DrivingLessonProduct extends PlannableProductInterface, ProductInterface {
    allowsReservations: Scalars['Boolean'];
    color: Scalars['String'];
    creditDisplayType: CreditDisplayTypeEnum;
    defaultDurationInMinutes: Scalars['Int'];
    drivingSchool: DrivingSchool;
    educationCategory: EducationCategory;
    id: Scalars['ID'];
    priceExcludingVat: Scalars['String'];
    pricePerDurationInMinutes: Scalars['Int'];
    title: Scalars['String'];
    type: ProductTypeEnum;
    vatPercentage: VatPercentage;
}

export interface DrivingSchool {
    cbrId: Scalars['String'];
    coc?: Maybe<Scalars['String']>;
    connectCode: Scalars['Int'];
    contacts: Array<Contact>;
    createdAt: Scalars['DateTime'];
    iban?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    invoiceAddress?: Maybe<Address>;
    name: Scalars['String'];
    organization: Organization;
    phone?: Maybe<Scalars['String']>;
    pickupAddress?: Maybe<Address>;
    postalAddress?: Maybe<Address>;
    roadmaps: Array<Roadmap>;
    updatedAt: Scalars['DateTime'];
    vat?: Maybe<Scalars['String']>;
    vehicles: Array<Vehicle>;
    visitAddress?: Maybe<Address>;
}

export interface EducationCategoriesInput {
    hasRoadmap?: InputMaybe<Scalars['Boolean']>;
}

export interface EducationCategory {
    icon?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name: Scalars['String'];
}

export interface EligibleForHomeworkInput {
    roadmapProgressId: Scalars['ID'];
}

export enum EventStatusEnum {
    Cancelled = 'CANCELLED',
    Final = 'FINAL',
    Reservation = 'RESERVATION',
}

export interface ExamMilestone extends MilestoneInterface {
    examType: ExamTypeEnum;
    icon?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    subTitle?: Maybe<Scalars['String']>;
    title: Scalars['String'];
    type: MilestoneTypeEnum;
}

export interface ExamMilestonesInput {
    ids: Array<Scalars['ID']>;
}

export interface ExamProduct extends PlannableProductInterface, ProductInterface {
    color: Scalars['String'];
    defaultDurationInMinutes: Scalars['Int'];
    drivingSchool: DrivingSchool;
    educationCategory: EducationCategory;
    examType: ExamTypeEnum;
    id: Scalars['ID'];
    priceExcludingVat: Scalars['String'];
    purchasePrice: Scalars['String'];
    title: Scalars['String'];
    type: ProductTypeEnum;
    vatPercentage: VatPercentage;
}

export enum ExamTypeEnum {
    Practical = 'PRACTICAL',
    Theoretical = 'THEORETICAL',
}

export interface ForgotPasswordInput {
    email: Scalars['String'];
}

export interface ForgotPasswordResponse {
    message?: Maybe<Scalars['String']>;
    status: Scalars['String'];
}

export interface GenericProduct extends ProductInterface {
    drivingSchool: DrivingSchool;
    educationCategory: EducationCategory;
    id: Scalars['ID'];
    priceExcludingVat: Scalars['String'];
    title: Scalars['String'];
    type: ProductTypeEnum;
    vatPercentage: VatPercentage;
}

export enum GoalEnum {
    Freedom = 'FREEDOM',
    Friends = 'FRIENDS',
    Holiday = 'HOLIDAY',
    NoPublicTransport = 'NO_PUBLIC_TRANSPORT',
    School = 'SCHOOL',
    Work = 'WORK',
}

export interface HomeworkInput {
    roadmapProgressId: Scalars['ID'];
}

export interface Image {
    altText?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    image: Scalars['String'];
    title: Scalars['String'];
}

export interface Instructor {
    avatar?: Maybe<Scalars['String']>;
    cbrId?: Maybe<Scalars['String']>;
    drivingSchools: Array<DrivingSchool>;
    educationCategories: Array<EducationCategory>;
    id: Scalars['ID'];
    phone?: Maybe<Scalars['String']>;
    preferredVehicle?: Maybe<Vehicle>;
    roadmapProgresses: Array<RoadmapProgress>;
    user: User;
}

export interface InstructorInput {
    id: Scalars['ID'];
}

/** A paginated list of Instructor items. */
export interface InstructorPaginator {
    /** A list of Instructor items. */
    data: Array<Instructor>;
    /** Pagination information about the list of items. */
    paginatorInfo: PaginatorInfo;
}

export interface InviteStudentToDrivingSchoolInput {
    drivingSchoolId: Scalars['ID'];
    id: Scalars['ID'];
}

export interface InviteStudentToDrivingSchoolResponse {
    status: InviteStudentToDrivingSchoolStatusEnum;
}

export enum InviteStudentToDrivingSchoolStatusEnum {
    AlreadyConnected = 'ALREADY_CONNECTED',
    AlreadyInvited = 'ALREADY_INVITED',
    Invited = 'INVITED',
}

export interface LoginInput {
    email: Scalars['String'];
    password: Scalars['String'];
}

export interface LogoutResponse {
    message?: Maybe<Scalars['String']>;
    status: Scalars['String'];
}

export interface Mileage {
    createdAt: Scalars['DateTime'];
    id: Scalars['ID'];
    kilometers: Scalars['Int'];
    notes?: Maybe<Scalars['String']>;
    registeredAt: Scalars['DateTime'];
    updatedAt: Scalars['DateTime'];
    vehicle?: Maybe<Vehicle>;
}

/** A paginated list of Mileage items. */
export interface MileagePaginator {
    /** A list of Mileage items. */
    data: Array<Mileage>;
    /** Pagination information about the list of items. */
    paginatorInfo: PaginatorInfo;
}

export type Milestone = ExamMilestone | PracticeMilestone | ReviewMilestone | TestMilestone | TheoryMilestone;

export interface MilestoneInterface {
    icon?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    subTitle?: Maybe<Scalars['String']>;
    title: Scalars['String'];
    type: MilestoneTypeEnum;
}

export interface MilestoneProgress {
    milestoneId: Scalars['ID'];
    progress: Scalars['Int'];
}

export interface MilestoneProgressesInput {
    milestoneIds?: InputMaybe<Array<Scalars['ID']>>;
    roadmapProgressId: Scalars['ID'];
}

export enum MilestoneTypeEnum {
    Exam = 'EXAM',
    Practice = 'PRACTICE',
    Review = 'REVIEW',
    Test = 'TEST',
    Theory = 'THEORY',
}

export interface Mutation {
    acceptInviteStudentToDrivingSchool: AcceptInviteStudentToDrivingSchoolResponse;
    connectStudentToDrivingSchool: ConnectStudentToDrivingSchoolResponse;
    createCalendarEvent: CalendarEvent;
    createCalendarEventNote: CalendarEventNote;
    createMileage: Mileage;
    createRoadmapPaywallCode: Scalars['Boolean'];
    createScriptNote: ScriptNote;
    createScriptResult: ScriptResult;
    createStudent: CreateStudentResponse;
    createStudentNote: StudentNote;
    createVehicle: Vehicle;
    createWalletMutation: Scalars['Boolean'];
    deleteCalendarEvent: CalendarEvent;
    deleteCalendarEventNote: CalendarEventNote;
    deleteMileage: Vehicle;
    deleteScriptNote: ScriptNote;
    deleteStudentNote: StudentNote;
    deleteVehicle: Vehicle;
    forgotPassword: ForgotPasswordResponse;
    inviteStudentToDrivingSchool: InviteStudentToDrivingSchoolResponse;
    login: AuthPayload;
    logout: LogoutResponse;
    redeemRoadmapPaywallCode: Scalars['Boolean'];
    refreshToken: RefreshTokenPayload;
    registerStudent: RegisterStudentResponse;
    resendEmailVerificationLink: Scalars['String'];
    resetPassword: ForgotPasswordResponse;
    updateCalendarEvent: CalendarEvent;
    updateCalendarEventNote: CalendarEventNote;
    updatePassword: UpdatePasswordResponse;
    updateScriptNote: ScriptNote;
    updateStudent: Student;
    updateStudentNote: StudentNote;
    updateVehicle: Vehicle;
    verifyEmail: VerifyEmailResponse;
}


export interface MutationAcceptInviteStudentToDrivingSchoolArgs {
    input: AcceptInviteStudentToDrivingSchoolInput;
}


export interface MutationConnectStudentToDrivingSchoolArgs {
    input: ConnectStudentToDrivingSchoolInput;
}


export interface MutationCreateCalendarEventArgs {
    input: CreateCalendarEventInput;
}


export interface MutationCreateCalendarEventNoteArgs {
    input: CreateCalendarEventNoteInput;
}


export interface MutationCreateMileageArgs {
    input: CreateMileageInput;
}


export interface MutationCreateRoadmapPaywallCodeArgs {
    input: CreateRoadmapPaywallCodeInput;
}


export interface MutationCreateScriptNoteArgs {
    input: CreateScriptNoteInput;
}


export interface MutationCreateScriptResultArgs {
    input: CreateScriptResultInput;
}


export interface MutationCreateStudentArgs {
    input: CreateStudentInput;
}


export interface MutationCreateStudentNoteArgs {
    input: CreateStudentNoteInput;
}


export interface MutationCreateVehicleArgs {
    input: CreateVehicleInput;
}


export interface MutationCreateWalletMutationArgs {
    input: CreateWalletMutationInput;
}


export interface MutationDeleteCalendarEventArgs {
    input: DeleteCalendarEventInput;
}


export interface MutationDeleteCalendarEventNoteArgs {
    input: DeleteCalendarEventNoteInput;
}


export interface MutationDeleteMileageArgs {
    input: DeleteMileageInput;
}


export interface MutationDeleteScriptNoteArgs {
    input: DeleteScriptNoteInput;
}


export interface MutationDeleteStudentNoteArgs {
    input: DeleteStudentNoteInput;
}


export interface MutationDeleteVehicleArgs {
    input: DeleteVehicleInput;
}


export interface MutationForgotPasswordArgs {
    input: ForgotPasswordInput;
}


export interface MutationInviteStudentToDrivingSchoolArgs {
    input: InviteStudentToDrivingSchoolInput;
}


export interface MutationLoginArgs {
    input?: InputMaybe<LoginInput>;
}


export interface MutationRedeemRoadmapPaywallCodeArgs {
    input: RedeemRoadmapPaywallCodeInput;
}


export interface MutationRefreshTokenArgs {
    input?: InputMaybe<RefreshTokenInput>;
}


export interface MutationRegisterStudentArgs {
    input: RegisterStudentInput;
}


export interface MutationResetPasswordArgs {
    input?: InputMaybe<NewPasswordWithCodeInput>;
}


export interface MutationUpdateCalendarEventArgs {
    input: UpdateCalendarEventInput;
}


export interface MutationUpdateCalendarEventNoteArgs {
    input: UpdateCalendarEventNoteInput;
}


export interface MutationUpdatePasswordArgs {
    input: UpdatePasswordInput;
}


export interface MutationUpdateScriptNoteArgs {
    input: UpdateScriptNoteInput;
}


export interface MutationUpdateStudentArgs {
    input: UpdateStudentInput;
}


export interface MutationUpdateStudentNoteArgs {
    input: UpdateStudentNoteInput;
}


export interface MutationUpdateVehicleArgs {
    input: UpdateVehicleInput;
}


export interface MutationVerifyEmailArgs {
    input: VerifyEmailInput;
}

export interface NewPasswordWithCodeInput {
    email: Scalars['String'];
    password: Scalars['String'];
    token: Scalars['String'];
}

export interface NoteInterface {
    author: User;
    createdAt: Scalars['DateTime'];
    id: Scalars['ID'];
    text: Scalars['String'];
    updatedAt: Scalars['DateTime'];
}

/** Allows ordering a list of records. */
export interface OrderByClause {
    /** The column that is used for ordering. */
    column: Scalars['String'];
    /** The direction that is used for ordering. */
    order: SortOrder;
}

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
    /** Amount of items. */
    Count = 'COUNT',
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
    /** Average. */
    Avg = 'AVG',
    /** Amount of items. */
    Count = 'COUNT',
    /** Maximum. */
    Max = 'MAX',
    /** Minimum. */
    Min = 'MIN',
    /** Sum. */
    Sum = 'SUM',
}

export interface Organization {
    calendarEventTypes: Array<CalendarEventType>;
    createdAt: Scalars['DateTime'];
    drivingSchools: Array<DrivingSchool>;
    id: Scalars['ID'];
    name: Scalars['String'];
    updatedAt: Scalars['DateTime'];
}

export interface Package {
    drivingSchool: DrivingSchool;
    educationCategory: EducationCategory;
    id: Scalars['ID'];
    packageProducts: Array<PackageProduct>;
    title: Scalars['String'];
}

export interface PackageProduct {
    id: Scalars['ID'];
    package: Package;
    product: Product;
    quantity: Scalars['Int'];
    unitPriceExcludingVat: Scalars['String'];
}

export interface PackagesInput {
    drivingSchoolId: Scalars['ID'];
}

/** Information about pagination using a fully featured paginator. */
export interface PaginatorInfo {
    /** Number of items in the current page. */
    count: Scalars['Int'];
    /** Index of the current page. */
    currentPage: Scalars['Int'];
    /** Index of the first item in the current page. */
    firstItem?: Maybe<Scalars['Int']>;
    /** Are there more pages after this one? */
    hasMorePages: Scalars['Boolean'];
    /** Index of the last item in the current page. */
    lastItem?: Maybe<Scalars['Int']>;
    /** Index of the last available page. */
    lastPage: Scalars['Int'];
    /** Number of items per page. */
    perPage: Scalars['Int'];
    /** Number of total available items. */
    total: Scalars['Int'];
}

export interface Paragraph {
    id: Scalars['ID'];
    paragraphSections: Array<ParagraphSection>;
    title: Scalars['String'];
}

export interface ParagraphSection {
    contents: Array<Content>;
    id: Scalars['ID'];
    title: Scalars['String'];
}

export interface PlannableProductInterface {
    color: Scalars['String'];
    defaultDurationInMinutes: Scalars['Int'];
    drivingSchool: DrivingSchool;
    educationCategory: EducationCategory;
    id: Scalars['ID'];
    priceExcludingVat: Scalars['String'];
    title: Scalars['String'];
    type: ProductTypeEnum;
    vatPercentage: VatPercentage;
}

export enum PlatformEnum {
    Android = 'ANDROID',
    Ios = 'IOS',
}

export interface PracticeMilestone extends MilestoneInterface {
    contents: Array<Content>;
    icon?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    ratingType: ScriptRatingTypeEnum;
    scripts: Array<Script>;
    subTitle?: Maybe<Scalars['String']>;
    title: Scalars['String'];
    type: MilestoneTypeEnum;
}

export interface PracticeMilestonesInput {
    ids: Array<Scalars['ID']>;
}

export type Product = CourseProduct | DrivingLessonProduct | ExamProduct | GenericProduct;

export interface ProductInterface {
    drivingSchool: DrivingSchool;
    educationCategory: EducationCategory;
    id: Scalars['ID'];
    priceExcludingVat: Scalars['String'];
    title: Scalars['String'];
    type: ProductTypeEnum;
    vatPercentage: VatPercentage;
}

export interface ProductObjectInput {
    id: Scalars['ID'];
    type: ProductTypeEnum;
}

export enum ProductTypeEnum {
    Course = 'COURSE',
    DrivingLesson = 'DRIVING_LESSON',
    Exam = 'EXAM',
    Product = 'PRODUCT',
}

export interface ProductsInput {
    drivingSchoolId: Scalars['ID'];
    educationCategoryId?: InputMaybe<Scalars['ID']>;
    isPlannable?: InputMaybe<Scalars['Boolean']>;
}

export interface Query {
    calendarEvent?: Maybe<CalendarEvent>;
    calendarEventNotes: Array<CalendarEventNote>;
    calendarEvents: Array<CalendarEvent>;
    educationCategories: Array<EducationCategory>;
    eligibleForHomework: Array<Script>;
    examMilestones: Array<ExamMilestone>;
    homework: Array<Script>;
    instructor: Instructor;
    instructors: InstructorPaginator;
    me: User;
    mileages: MileagePaginator;
    milestoneProgresses: Array<MilestoneProgress>;
    packages: Array<Package>;
    practiceMilestones: Array<PracticeMilestone>;
    products: Array<Product>;
    reviewMilestones: Array<ReviewMilestone>;
    roadmapProgresses: Array<RoadmapProgress>;
    scriptNotes: Array<ScriptNote>;
    scriptProgresses: Array<ScriptProgress>;
    scriptResults: Array<ScriptResult>;
    student: Student;
    studentNotes: Array<StudentNote>;
    students: StudentPaginator;
    testMilestones: Array<TestMilestone>;
    theoryMilestones: Array<TheoryMilestone>;
    updateCheck: UpdateCheckResponse;
    usedRelatedScripts: Array<Script>;
    vehicle: Vehicle;
    vehicles: VehiclePaginator;
    wallets: Array<Wallet>;
    workInProgress: Array<Script>;
}


export interface QueryCalendarEventArgs {
    input: CalendarEventInput;
}


export interface QueryCalendarEventNotesArgs {
    input: CalendarEventNotesInput;
    orderBy?: InputMaybe<Array<QueryCalendarEventNotesOrderByOrderByClause>>;
}


export interface QueryCalendarEventsArgs {
    input: CalendarEventsInput;
    orderBy?: InputMaybe<Array<QueryCalendarEventsOrderByOrderByClause>>;
}


export interface QueryEducationCategoriesArgs {
    input?: InputMaybe<EducationCategoriesInput>;
}


export interface QueryEligibleForHomeworkArgs {
    input: EligibleForHomeworkInput;
}


export interface QueryExamMilestonesArgs {
    input: ExamMilestonesInput;
}


export interface QueryHomeworkArgs {
    input: HomeworkInput;
}


export interface QueryInstructorArgs {
    input: InstructorInput;
}


export interface QueryInstructorsArgs {
    first: Scalars['Int'];
    orderBy?: InputMaybe<Array<QueryInstructorsOrderByOrderByClause>>;
    page?: InputMaybe<Scalars['Int']>;
    search?: InputMaybe<Scalars['String']>;
}


export interface QueryMileagesArgs {
    first: Scalars['Int'];
    orderBy?: InputMaybe<Array<QueryMileagesOrderByOrderByClause>>;
    page?: InputMaybe<Scalars['Int']>;
    vehicleId: Scalars['ID'];
}


export interface QueryMilestoneProgressesArgs {
    input: MilestoneProgressesInput;
}


export interface QueryPackagesArgs {
    input: PackagesInput;
}


export interface QueryPracticeMilestonesArgs {
    input: PracticeMilestonesInput;
}


export interface QueryProductsArgs {
    input: ProductsInput;
}


export interface QueryReviewMilestonesArgs {
    input: ReviewMilestonesInput;
}


export interface QueryRoadmapProgressesArgs {
    input?: InputMaybe<RoadmapProgressesInput>;
}


export interface QueryScriptNotesArgs {
    input: ScriptNotesInput;
    orderBy?: InputMaybe<Array<QueryScriptNotesOrderByOrderByClause>>;
}


export interface QueryScriptProgressesArgs {
    input: ScriptProgressesInput;
}


export interface QueryScriptResultsArgs {
    input: ScriptResultsInput;
}


export interface QueryStudentArgs {
    input: StudentInput;
}


export interface QueryStudentNotesArgs {
    input: StudentNotesInput;
    orderBy?: InputMaybe<Array<QueryStudentNotesOrderByOrderByClause>>;
}


export interface QueryStudentsArgs {
    first: Scalars['Int'];
    orderBy?: InputMaybe<Array<QueryStudentsOrderByOrderByClause>>;
    page?: InputMaybe<Scalars['Int']>;
    search?: InputMaybe<Scalars['String']>;
}


export interface QueryTestMilestonesArgs {
    input: TestMilestonesInput;
}


export interface QueryTheoryMilestonesArgs {
    input: TheoryMilestonesInput;
}


export interface QueryUpdateCheckArgs {
    input: UpdateCheckInput;
}


export interface QueryUsedRelatedScriptsArgs {
    input: UsedRelatedScriptsInput;
}


export interface QueryVehicleArgs {
    input: VehicleInput;
}


export interface QueryVehiclesArgs {
    first: Scalars['Int'];
    orderBy?: InputMaybe<Array<QueryVehiclesOrderByOrderByClause>>;
    page?: InputMaybe<Scalars['Int']>;
    search?: InputMaybe<Scalars['String']>;
}


export interface QueryWalletsArgs {
    input: WalletsInput;
}


export interface QueryWorkInProgressArgs {
    input: WorkInProgressInput;
}

/** Allowed column names for Query.calendarEventNotes.orderBy. */
export enum QueryCalendarEventNotesOrderByColumn {
    CreatedAt = 'CREATED_AT',
}

/** Order by clause for Query.calendarEventNotes.orderBy. */
export interface QueryCalendarEventNotesOrderByOrderByClause {
    /** The column that is used for ordering. */
    column: QueryCalendarEventNotesOrderByColumn;
    /** The direction that is used for ordering. */
    order: SortOrder;
}

/** Allowed column names for Query.calendarEvents.orderBy. */
export enum QueryCalendarEventsOrderByColumn {
    StartsAt = 'STARTS_AT',
}

/** Order by clause for Query.calendarEvents.orderBy. */
export interface QueryCalendarEventsOrderByOrderByClause {
    /** The column that is used for ordering. */
    column: QueryCalendarEventsOrderByColumn;
    /** The direction that is used for ordering. */
    order: SortOrder;
}

/** Allowed column names for Query.instructors.orderBy. */
export enum QueryInstructorsOrderByColumn {
    FirstName = 'FIRST_NAME',
}

/** Order by clause for Query.instructors.orderBy. */
export interface QueryInstructorsOrderByOrderByClause {
    /** The column that is used for ordering. */
    column: QueryInstructorsOrderByColumn;
    /** The direction that is used for ordering. */
    order: SortOrder;
}

/** Allowed column names for Query.mileages.orderBy. */
export enum QueryMileagesOrderByColumn {
    RegisteredAt = 'REGISTERED_AT',
}

/** Order by clause for Query.mileages.orderBy. */
export interface QueryMileagesOrderByOrderByClause {
    /** The column that is used for ordering. */
    column: QueryMileagesOrderByColumn;
    /** The direction that is used for ordering. */
    order: SortOrder;
}

/** Allowed column names for Query.scriptNotes.orderBy. */
export enum QueryScriptNotesOrderByColumn {
    CreatedAt = 'CREATED_AT',
}

/** Order by clause for Query.scriptNotes.orderBy. */
export interface QueryScriptNotesOrderByOrderByClause {
    /** The column that is used for ordering. */
    column: QueryScriptNotesOrderByColumn;
    /** The direction that is used for ordering. */
    order: SortOrder;
}

/** Allowed column names for Query.studentNotes.orderBy. */
export enum QueryStudentNotesOrderByColumn {
    CreatedAt = 'CREATED_AT',
}

/** Order by clause for Query.studentNotes.orderBy. */
export interface QueryStudentNotesOrderByOrderByClause {
    /** The column that is used for ordering. */
    column: QueryStudentNotesOrderByColumn;
    /** The direction that is used for ordering. */
    order: SortOrder;
}

/** Allowed column names for Query.students.orderBy. */
export enum QueryStudentsOrderByColumn {
    FirstName = 'FIRST_NAME',
}

/** Order by clause for Query.students.orderBy. */
export interface QueryStudentsOrderByOrderByClause {
    /** The column that is used for ordering. */
    column: QueryStudentsOrderByColumn;
    /** The direction that is used for ordering. */
    order: SortOrder;
}

/** Allowed column names for Query.vehicles.orderBy. */
export enum QueryVehiclesOrderByColumn {
    Name = 'NAME',
}

/** Order by clause for Query.vehicles.orderBy. */
export interface QueryVehiclesOrderByOrderByClause {
    /** The column that is used for ordering. */
    column: QueryVehiclesOrderByColumn;
    /** The direction that is used for ordering. */
    order: SortOrder;
}

export interface RatedQuiz {
    id: Scalars['ID'];
    max: Scalars['Int'];
    min: Scalars['Int'];
    questionSets: Array<RatedQuizQuestionSet>;
}

export interface RatedQuizQuestion {
    id: Scalars['ID'];
    question: Scalars['String'];
}

export interface RatedQuizQuestionSet {
    id: Scalars['ID'];
    questions: Array<RatedQuizQuestion>;
    title: Scalars['String'];
}

export interface RedeemRoadmapPaywallCodeInput {
    code: Scalars['String'];
}

export interface RefreshTokenInput {
    refreshToken: Scalars['String'];
}

export interface RefreshTokenPayload {
    accessToken: Scalars['String'];
    expiresIn: Scalars['Int'];
    refreshToken: Scalars['String'];
    tokenType: Scalars['String'];
}

export interface RegisterResponse {
    status: RegisterStatuses;
    tokens: AuthPayload;
}

export enum RegisterStatuses {
    MustVerifyEmail = 'MUST_VERIFY_EMAIL',
    Success = 'SUCCESS',
}

export interface RegisterStudentInput {
    educationCategoryId?: InputMaybe<Scalars['ID']>;
    email: Scalars['String'];
    firstName: Scalars['String'];
    goal: GoalEnum;
    hasPassedTheoryExam: Scalars['Boolean'];
    lastName: Scalars['String'];
    password: Scalars['String'];
}

export interface RegisterStudentResponse {
    registerResponse: RegisterResponse;
    student: Student;
}

export interface RelatedScript {
    id: Scalars['ID'];
    scriptSections: Array<ScriptSection>;
    title: Scalars['String'];
    video?: Maybe<Video>;
}

export interface ReviewMilestone extends MilestoneInterface {
    icon?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    quiz: RatedQuiz;
    subTitle?: Maybe<Scalars['String']>;
    title: Scalars['String'];
    type: MilestoneTypeEnum;
}

export interface ReviewMilestonesInput {
    ids: Array<Scalars['ID']>;
}

export interface Roadmap {
    educationCategory: EducationCategory;
    hasPaywallAccess: Scalars['Boolean'];
    id: Scalars['ID'];
    milestones: Array<Milestone>;
    title: Scalars['String'];
}

export enum RoadmapPaywallCodeDurationEnum {
    OneMonth = 'ONE_MONTH',
    SixMonths = 'SIX_MONTHS',
    ThreeMonths = 'THREE_MONTHS',
}

export interface RoadmapProgress {
    createdAt: Scalars['DateTime'];
    goal: GoalEnum;
    id: Scalars['ID'];
    roadmap: Roadmap;
    updatedAt: Scalars['DateTime'];
}

export interface RoadmapProgressesInput {
    studentId?: InputMaybe<Scalars['ID']>;
}

export interface Role {
    id: Scalars['ID'];
    name: RoleEnum;
}

export enum RoleEnum {
    Admin = 'ADMIN',
    DrivingSchoolAdmin = 'DRIVING_SCHOOL_ADMIN',
    Instructor = 'INSTRUCTOR',
    OrganizationAdmin = 'ORGANIZATION_ADMIN',
    Student = 'STUDENT',
}

export interface Script {
    id: Scalars['ID'];
    practiceMilestone: PracticeMilestone;
    relatedScripts: Array<RelatedScript>;
    scriptSections: Array<ScriptSection>;
    testExercises: Array<TestExercise>;
    title: Scalars['String'];
    video?: Maybe<Video>;
}

export interface ScriptNote extends NoteInterface {
    author: User;
    createdAt: Scalars['DateTime'];
    id: Scalars['ID'];
    roadmapProgress: RoadmapProgress;
    script: Script;
    text: Scalars['String'];
    updatedAt: Scalars['DateTime'];
    visibleForStudent: Scalars['Boolean'];
}

export interface ScriptNotesInput {
    roadmapProgressId: Scalars['ID'];
    scriptId: Scalars['ID'];
}

export interface ScriptProgress {
    passed: Scalars['Boolean'];
    progress: Scalars['Int'];
    scriptId: Scalars['ID'];
}

export interface ScriptProgressesInput {
    practiceMilestoneId?: InputMaybe<Scalars['ID']>;
    roadmapProgressId: Scalars['ID'];
    scriptIds?: InputMaybe<Array<Scalars['ID']>>;
}

export enum ScriptRatingEnum {
    ActIndependently = 'ACT_INDEPENDENTLY',
    ActOnChangedSituations = 'ACT_ON_CHANGED_SITUATIONS',
    ActOnDirections = 'ACT_ON_DIRECTIONS',
    ActOnLimitedDirections = 'ACT_ON_LIMITED_DIRECTIONS',
    ActWithoutDirections = 'ACT_WITHOUT_DIRECTIONS',
    Demo = 'DEMO',
    ExplainedByStudent = 'EXPLAINED_BY_STUDENT',
    Homework = 'HOMEWORK',
    StvEducation = 'STV_EDUCATION',
    StvFormation = 'STV_FORMATION',
    StvTraining = 'STV_TRAINING',
    Tool = 'TOOL',
}

export enum ScriptRatingTypeEnum {
    Default = 'DEFAULT',
    Stv = 'STV',
}

export interface ScriptResult {
    calendarEvent?: Maybe<CalendarEvent>;
    contextualScript?: Maybe<Script>;
    createdAt: Scalars['DateTime'];
    id: Scalars['ID'];
    rating: ScriptRatingEnum;
    script: Script;
    updatedAt: Scalars['DateTime'];
}

export interface ScriptResultsInput {
    calendarEventId?: InputMaybe<Scalars['ID']>;
    roadmapProgressId: Scalars['ID'];
    scriptId?: InputMaybe<Scalars['ID']>;
}

export interface ScriptSection {
    contents: Array<Content>;
    header?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    title: Scalars['String'];
}

/** Directions for ordering a list of records. */
export enum SortOrder {
    /** Sort records in ascending order. */
    Asc = 'ASC',
    /** Sort records in descending order. */
    Desc = 'DESC',
}

export interface Student {
    avatar?: Maybe<Scalars['String']>;
    birthdate?: Maybe<Scalars['Date']>;
    cbrId?: Maybe<Scalars['String']>;
    contacts: Array<Contact>;
    drivingSchools: Array<DrivingSchool>;
    id: Scalars['ID'];
    invoiceAddress?: Maybe<Address>;
    phone?: Maybe<Scalars['String']>;
    pickupAddress?: Maybe<Address>;
    postalAddress?: Maybe<Address>;
    preferredInstructors: Array<Instructor>;
    roadmapProgresses: Array<RoadmapProgress>;
    user: User;
}

export interface StudentInput {
    id: Scalars['ID'];
}

export interface StudentNote extends NoteInterface {
    author: User;
    createdAt: Scalars['DateTime'];
    id: Scalars['ID'];
    student: Student;
    text: Scalars['String'];
    updatedAt: Scalars['DateTime'];
}

export interface StudentNotesInput {
    studentId: Scalars['ID'];
}

/** A paginated list of Student items. */
export interface StudentPaginator {
    /** A list of Student items. */
    data: Array<Student>;
    /** Pagination information about the list of items. */
    paginatorInfo: PaginatorInfo;
}

export interface TestExercise {
    description: Scalars['String'];
    id: Scalars['ID'];
    title: Scalars['String'];
}

export interface TestMilestone extends MilestoneInterface {
    icon?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    subTitle?: Maybe<Scalars['String']>;
    testType: TestTypeEnum;
    title: Scalars['String'];
    type: MilestoneTypeEnum;
}

export interface TestMilestonesInput {
    ids: Array<Scalars['ID']>;
}

export enum TestTypeEnum {
    External = 'EXTERNAL',
    Internal = 'INTERNAL',
}

export interface Text {
    id: Scalars['ID'];
    text: Scalars['String'];
    title: Scalars['String'];
}

export interface TheoryMilestone extends MilestoneInterface {
    chapters: Array<Chapter>;
    icon?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    subTitle?: Maybe<Scalars['String']>;
    title: Scalars['String'];
    type: MilestoneTypeEnum;
}

export interface TheoryMilestonesInput {
    ids: Array<Scalars['ID']>;
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
    /** Only return trashed results. */
    Only = 'ONLY',
    /** Return both trashed and non-trashed results. */
    With = 'WITH',
    /** Only return non-trashed results. */
    Without = 'WITHOUT',
}

export interface UpdateCalendarEventInput {
    description?: InputMaybe<Scalars['String']>;
    endsAt?: InputMaybe<Scalars['DateTime']>;
    id: Scalars['ID'];
    instructorIds?: InputMaybe<Array<Scalars['ID']>>;
    location?: InputMaybe<Scalars['String']>;
    startsAt?: InputMaybe<Scalars['DateTime']>;
    status?: InputMaybe<EventStatusEnum>;
    studentIds?: InputMaybe<Array<Scalars['ID']>>;
    tableNumber?: InputMaybe<Scalars['String']>;
    title?: InputMaybe<Scalars['String']>;
    userIds?: InputMaybe<Array<Scalars['ID']>>;
    vehicleIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface UpdateCalendarEventNoteInput {
    id: Scalars['ID'];
    text: Scalars['String'];
    visibleForStudent: Scalars['Boolean'];
}

export interface UpdateCheckInput {
    currentVersion: Scalars['String'];
    platform: PlatformEnum;
}

export interface UpdateCheckResponse {
    available: Scalars['Boolean'];
    promptConfirmButtonLabel: Scalars['String'];
    promptMessage: Scalars['String'];
}

export interface UpdatePasswordInput {
    currentPassword: Scalars['String'];
    password: Scalars['String'];
}

export interface UpdatePasswordResponse {
    message?: Maybe<Scalars['String']>;
    status: Scalars['String'];
}

export interface UpdateScriptNoteInput {
    id: Scalars['ID'];
    text: Scalars['String'];
    visibleForStudent: Scalars['Boolean'];
}

export interface UpdateStudentInput {
    avatar?: InputMaybe<Scalars['Upload']>;
    birthdate?: InputMaybe<Scalars['Date']>;
    cbrId?: InputMaybe<Scalars['String']>;
    email?: InputMaybe<Scalars['String']>;
    firstName?: InputMaybe<Scalars['String']>;
    id: Scalars['ID'];
    invoiceAddress?: InputMaybe<AddressInput>;
    lastName?: InputMaybe<Scalars['String']>;
    phone?: InputMaybe<Scalars['String']>;
    pickupAddress?: InputMaybe<AddressInput>;
    postalAddress?: InputMaybe<AddressInput>;
    preferredInstructorIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface UpdateStudentNoteInput {
    id: Scalars['ID'];
    text: Scalars['String'];
}

export interface UpdateVehicleInput {
    brand: Scalars['String'];
    cbrId?: InputMaybe<Scalars['String']>;
    id: Scalars['ID'];
    licensePlate: Scalars['String'];
    model: Scalars['String'];
    name?: InputMaybe<Scalars['String']>;
    year: Scalars['Int'];
}

export interface UsedRelatedScriptsInput {
    calendarEventId?: InputMaybe<Scalars['ID']>;
    roadmapProgressId: Scalars['ID'];
    scriptId: Scalars['ID'];
}

export interface User {
    createdAt: Scalars['DateTime'];
    drivingSchools: Array<DrivingSchool>;
    email: Scalars['String'];
    firstName: Scalars['String'];
    id: Scalars['ID'];
    instructor?: Maybe<Instructor>;
    lastName: Scalars['String'];
    organizations: Array<Organization>;
    roles: Array<Role>;
    student?: Maybe<Student>;
    updatedAt: Scalars['DateTime'];
}

export interface VatPercentage {
    amount: Scalars['String'];
    id: Scalars['ID'];
}

export interface Vehicle {
    brand: Scalars['String'];
    cbrId?: Maybe<Scalars['String']>;
    createdAt: Scalars['DateTime'];
    drivingSchool: DrivingSchool;
    id: Scalars['ID'];
    licensePlate: Scalars['String'];
    model: Scalars['String'];
    name?: Maybe<Scalars['String']>;
    updatedAt: Scalars['DateTime'];
    year: Scalars['Int'];
}

export interface VehicleInput {
    id: Scalars['ID'];
}

/** A paginated list of Vehicle items. */
export interface VehiclePaginator {
    /** A list of Vehicle items. */
    data: Array<Vehicle>;
    /** Pagination information about the list of items. */
    paginatorInfo: PaginatorInfo;
}

export interface VerifyEmailInput {
    expires: Scalars['Int'];
    hash: Scalars['String'];
    id: Scalars['ID'];
    signature: Scalars['String'];
}

export interface VerifyEmailResponse {
    status: Scalars['String'];
}

export interface Video {
    id: Scalars['ID'];
    provider: VideoProviderEnum;
    proxyUrl?: Maybe<Scalars['String']>;
    title: Scalars['String'];
    videoId: Scalars['String'];
}

export enum VideoProviderEnum {
    Vimeo = 'VIMEO',
    Youtube = 'YOUTUBE',
}

export interface Wallet {
    drivingSchool: DrivingSchool;
    product: ProductInterface;
    quantityAcquired: Scalars['Int'];
    quantityAvailable: Scalars['Int'];
    quantityPlanned: Scalars['Int'];
    quantityUsed: Scalars['Int'];
    student: Student;
}

export interface WalletsInput {
    drivingSchoolId: Scalars['ID'];
    product?: InputMaybe<ProductObjectInput>;
    studentId?: InputMaybe<Scalars['ID']>;
}

export interface WorkInProgressInput {
    roadmapProgressId: Scalars['ID'];
}

export type UpdateCheckQueryVariables = Exact<{
    input: UpdateCheckInput;
}>;


export type UpdateCheckQuery = { updateCheck: { available: boolean, promptMessage: string, promptConfirmButtonLabel: string } };

export type LoginFragment = { accessToken?: string | null, expiresIn?: number | null, refreshToken?: string | null, tokenType?: string | null };

export type RefreshTokenFragment = { accessToken: string, expiresIn: number, refreshToken: string, tokenType: string };

export type LoginMutationVariables = Exact<{
    input: LoginInput;
}>;


export type LoginMutation = { login: { accessToken?: string | null, expiresIn?: number | null, refreshToken?: string | null, tokenType?: string | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { logout: { status: string, message?: string | null } };

export type ForgotPasswordMutationVariables = Exact<{
    input: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { forgotPassword: { message?: string | null, status: string } };

export type ResetPasswordMutationVariables = Exact<{
    input?: InputMaybe<NewPasswordWithCodeInput>;
}>;


export type ResetPasswordMutation = { resetPassword: { message?: string | null, status: string } };

export type RefreshTokenMutationVariables = Exact<{
    input?: InputMaybe<RefreshTokenInput>;
}>;


export type RefreshTokenMutation = { refreshToken: { accessToken: string, expiresIn: number, refreshToken: string, tokenType: string } };

export type RegisterStudentMutationVariables = Exact<{
    input: RegisterStudentInput;
}>;


export type RegisterStudentMutation = { registerStudent: { registerResponse: { status: RegisterStatuses } } };

export type ResendEmailVerificationLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendEmailVerificationLinkMutation = { resendEmailVerificationLink: string };

export type EducationCategoryFragment = { id: string, name: string, icon?: string | null };

export type EventFragment = { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null };

export type CourseProductFragment = { id: string, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } };

export type DrivingLessonProductFragment = { id: string, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, pricePerDurationInMinutes: number, creditDisplayType: CreditDisplayTypeEnum, allowsReservations: boolean, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } };

export type ExamProductFragment = { id: string, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, examType: ExamTypeEnum, purchasePrice: string, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } };

export type GenericProductFragment = { id: string, title: string, priceExcludingVat: string, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } };

export type CreateCalendarEventMutationVariables = Exact<{
    input: CreateCalendarEventInput;
}>;


export type CreateCalendarEventMutation = { createCalendarEvent: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null } };

export type UpdateCalendarEventMutationVariables = Exact<{
    input: UpdateCalendarEventInput;
}>;


export type UpdateCalendarEventMutation = { updateCalendarEvent: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null } };

export type CalendarEventsQueryVariables = Exact<{
    input: CalendarEventsInput;
}>;


export type CalendarEventsQuery = { calendarEvents: Array<{ id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, product?: { type: ProductTypeEnum, id: string, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | { type: ProductTypeEnum, id: string, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, pricePerDurationInMinutes: number, creditDisplayType: CreditDisplayTypeEnum, allowsReservations: boolean, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | { type: ProductTypeEnum, id: string, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, examType: ExamTypeEnum, purchasePrice: string, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | { type: ProductTypeEnum, id: string, title: string, priceExcludingVat: string, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | null, calendarEventParticipants: Array<{ id: string, calendarEvent: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null }, actor: { id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } } | { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> } | { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } }>, type?: { id: string, name: string } | null }> };

export type CalendarEventQueryVariables = Exact<{
    input: CalendarEventInput;
}>;


export type CalendarEventQuery = { calendarEvent?: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, drivingSchool: { id: string, name: string, cbrId: string, connectCode: number, phone?: string | null, iban?: string | null, coc?: string | null, vat?: string | null, createdAt: any, updatedAt: any, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, visitAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, organization: { id: string, name: string, calendarEventTypes: Array<{ id: string, name: string }> }, vehicles: Array<{ id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any }> }, author: { id: string, firstName: string, lastName: string }, recurredFromEvent?: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null } | null, recurrences: Array<{ id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null }>, product?: { type: ProductTypeEnum, id: string, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | { type: ProductTypeEnum, id: string, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, pricePerDurationInMinutes: number, creditDisplayType: CreditDisplayTypeEnum, allowsReservations: boolean, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | { type: ProductTypeEnum, id: string, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, examType: ExamTypeEnum, purchasePrice: string, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | { type: ProductTypeEnum, id: string, title: string, priceExcludingVat: string, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | null, calendarEventParticipants: Array<{ id: string, calendarEvent: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null }, actor: { id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } } | { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> } | { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } }>, vehicles: Array<{ id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any }>, type?: { id: string, name: string } | null } | null };

export type EducationCategoriesQueryVariables = Exact<{
    input?: InputMaybe<EducationCategoriesInput>;
}>;


export type EducationCategoriesQuery = { educationCategories: Array<{ id: string, name: string, icon?: string | null }> };

export type CreateScriptResultMutationVariables = Exact<{
    input: CreateScriptResultInput;
}>;


export type CreateScriptResultMutation = { createScriptResult: { rating: ScriptRatingEnum, script: { id: string }, contextualScript?: { id: string } | null } };

export type EligibleForHomeworkQueryVariables = Exact<{
    input: EligibleForHomeworkInput;
}>;


export type EligibleForHomeworkQuery = { eligibleForHomework: Array<{ id: string, title: string, practiceMilestone: { id: string, title: string, ratingType: ScriptRatingTypeEnum } }> };

export type HomeworkQueryVariables = Exact<{
    input: HomeworkInput;
}>;


export type HomeworkQuery = { homework: Array<{ id: string, title: string, practiceMilestone: { id: string, title: string, ratingType: ScriptRatingTypeEnum }, relatedScripts: Array<{ id: string, title: string }>, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }>, testExercises: Array<{ id: string, title: string, description: string }>, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null }> };

export type UsedRelatedScriptsQueryVariables = Exact<{
    input: UsedRelatedScriptsInput;
}>;


export type UsedRelatedScriptsQuery = { usedRelatedScripts: Array<{ id: string, title: string }> };

export type InstructorFragment = { id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } };

export type InstructorPaginatorInfoFragment = { count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number };

export type InstructorsQueryVariables = Exact<{
    first: Scalars['Int'];
    page?: InputMaybe<Scalars['Int']>;
    orderBy?: InputMaybe<Array<QueryInstructorsOrderByOrderByClause> | QueryInstructorsOrderByOrderByClause>;
    search?: InputMaybe<Scalars['String']>;
}>;


export type InstructorsQuery = { instructors: { paginatorInfo: { count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> } };

export type InstructorQueryVariables = Exact<{
    input: InstructorInput;
}>;


export type InstructorQuery = { instructor: { id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } } };

export type StudentNoteFragment = { id: string, text: string, createdAt: any, updatedAt: any, student: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> }, author: { id: string, firstName: string, lastName: string, email: string, roles: Array<{ id: string, name: RoleEnum }> } };

export type ScriptNoteFragment = { id: string, text: string, visibleForStudent: boolean, createdAt: any, updatedAt: any, script: { title: string, id: string }, roadmapProgress: { id: string, goal: GoalEnum, roadmap: { title: string } }, author: { id: string, firstName: string, email: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } };

export type CalendarEventNoteFragment = { id: string, text: string, visibleForStudent: boolean, createdAt: any, updatedAt: any, calendarEvent: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null }, author: { id: string, firstName: string, email: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } };

export type DeleteStudentNoteMutationVariables = Exact<{
    input: DeleteStudentNoteInput;
}>;


export type DeleteStudentNoteMutation = { deleteStudentNote: { id: string, text: string, createdAt: any, updatedAt: any, student: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> }, author: { id: string, firstName: string, lastName: string, email: string, roles: Array<{ id: string, name: RoleEnum }> } } };

export type UpdateStudentNoteMutationVariables = Exact<{
    input: UpdateStudentNoteInput;
}>;


export type UpdateStudentNoteMutation = { updateStudentNote: { id: string, text: string, createdAt: any, updatedAt: any, student: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> }, author: { id: string, firstName: string, lastName: string, email: string, roles: Array<{ id: string, name: RoleEnum }> } } };

export type CreateStudentNoteMutationVariables = Exact<{
    input: CreateStudentNoteInput;
}>;


export type CreateStudentNoteMutation = { createStudentNote: { id: string, text: string, createdAt: any, updatedAt: any, student: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> }, author: { id: string, firstName: string, lastName: string, email: string, roles: Array<{ id: string, name: RoleEnum }> } } };

export type CreateScriptNoteMutationVariables = Exact<{
    input: CreateScriptNoteInput;
}>;


export type CreateScriptNoteMutation = { createScriptNote: { id: string, text: string, visibleForStudent: boolean, createdAt: any, updatedAt: any, script: { title: string, id: string }, roadmapProgress: { id: string, goal: GoalEnum, roadmap: { title: string } }, author: { id: string, firstName: string, email: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } } };

export type DeleteScriptNoteMutationVariables = Exact<{
    input: DeleteScriptNoteInput;
}>;


export type DeleteScriptNoteMutation = { deleteScriptNote: { id: string, text: string, visibleForStudent: boolean, createdAt: any, updatedAt: any, script: { title: string, id: string }, roadmapProgress: { id: string, goal: GoalEnum, roadmap: { title: string } }, author: { id: string, firstName: string, email: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } } };

export type UpdateScriptNoteMutationVariables = Exact<{
    input: UpdateScriptNoteInput;
}>;


export type UpdateScriptNoteMutation = { updateScriptNote: { id: string, text: string, visibleForStudent: boolean, createdAt: any, updatedAt: any, script: { title: string, id: string }, roadmapProgress: { id: string, goal: GoalEnum, roadmap: { title: string } }, author: { id: string, firstName: string, email: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } } };

export type CreateCalendarEventNoteMutationVariables = Exact<{
    input: CreateCalendarEventNoteInput;
}>;


export type CreateCalendarEventNoteMutation = { createCalendarEventNote: { id: string, text: string, visibleForStudent: boolean, createdAt: any, updatedAt: any, calendarEvent: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null }, author: { id: string, firstName: string, email: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } } };

export type DeleteCalendarEventNoteMutationVariables = Exact<{
    input: DeleteCalendarEventNoteInput;
}>;


export type DeleteCalendarEventNoteMutation = { deleteCalendarEventNote: { id: string, text: string, visibleForStudent: boolean, createdAt: any, updatedAt: any, calendarEvent: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null }, author: { id: string, firstName: string, email: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } } };

export type UpdateCalendarEventNoteMutationVariables = Exact<{
    input: UpdateCalendarEventNoteInput;
}>;


export type UpdateCalendarEventNoteMutation = { updateCalendarEventNote: { id: string, text: string, visibleForStudent: boolean, createdAt: any, updatedAt: any, calendarEvent: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null }, author: { id: string, firstName: string, email: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } } };

export type StudentNotesQueryVariables = Exact<{
    input: StudentNotesInput;
    orderBy?: InputMaybe<Array<QueryStudentNotesOrderByOrderByClause> | QueryStudentNotesOrderByOrderByClause>;
}>;


export type StudentNotesQuery = { studentNotes: Array<{ id: string, text: string, createdAt: any, updatedAt: any, student: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> }, author: { id: string, firstName: string, lastName: string, email: string, roles: Array<{ id: string, name: RoleEnum }> } }> };

export type ScriptNotesQueryVariables = Exact<{
    input: ScriptNotesInput;
    orderBy?: InputMaybe<Array<QueryScriptNotesOrderByOrderByClause> | QueryScriptNotesOrderByOrderByClause>;
}>;


export type ScriptNotesQuery = { scriptNotes: Array<{ id: string, text: string, visibleForStudent: boolean, createdAt: any, updatedAt: any, script: { title: string, id: string }, roadmapProgress: { id: string, goal: GoalEnum, roadmap: { title: string } }, author: { id: string, firstName: string, email: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } }> };

export type CalendarEventNotesQueryVariables = Exact<{
    input: CalendarEventNotesInput;
    orderBy?: InputMaybe<Array<QueryCalendarEventNotesOrderByOrderByClause> | QueryCalendarEventNotesOrderByOrderByClause>;
}>;


export type CalendarEventNotesQuery = { calendarEventNotes: Array<{ id: string, text: string, visibleForStudent: boolean, createdAt: any, updatedAt: any, calendarEvent: { id: string, status: EventStatusEnum, title: string, description?: string | null, startsAt: any, endsAt: any, location?: string | null, tableNumber?: string | null, type?: { id: string, name: string } | null }, author: { id: string, firstName: string, email: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } }> };

export type PackagesQueryVariables = Exact<{
    input: PackagesInput;
}>;


export type PackagesQuery = { packages: Array<{ id: string, title: string, drivingSchool: { id: string, name: string, cbrId: string, connectCode: number, organization: { id: string, name: string } }, packageProducts: Array<{ id: string, quantity: number, unitPriceExcludingVat: string, package: { id: string, title: string } }> }> };

export type ProductsQueryVariables = Exact<{
    input: ProductsInput;
}>;


export type ProductsQuery = { products: Array<{ id: string, type: ProductTypeEnum, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | { id: string, type: ProductTypeEnum, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, pricePerDurationInMinutes: number, creditDisplayType: CreditDisplayTypeEnum, allowsReservations: boolean, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | { id: string, type: ProductTypeEnum, title: string, priceExcludingVat: string, color: string, defaultDurationInMinutes: number, examType: ExamTypeEnum, purchasePrice: string, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } } | { id: string, type: ProductTypeEnum, title: string, priceExcludingVat: string, educationCategory: { id: string, name: string, icon?: string | null }, vatPercentage: { id: string, amount: string } }> };

export type PracticeMilestoneScriptFragment = { id: string, title: string, practiceMilestone: { id: string, title: string, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum }, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, relatedScripts: Array<{ id: string, title: string }>, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }>, testExercises: Array<{ id: string, title: string, description: string }> };

export type WorkInProgressScriptFragment = { id: string, title: string, practiceMilestone: { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, practiceMilestone: { id: string, title: string, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum }, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, relatedScripts: Array<{ id: string, title: string }>, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }>, testExercises: Array<{ id: string, title: string, description: string }> }>, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> } };

export type VideoFragment = { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum };

export type ImageFragment = { id: string, title: string, image: string, altText?: string | null };

export type TextFragment = { id: string, title: string, text: string };

export type ScriptSectionFragment = { id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> };

export type TestExerciseFragment = { id: string, title: string, description: string };

export type PracticeMileStoneFragment = { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, practiceMilestone: { id: string, title: string, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum }, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, relatedScripts: Array<{ id: string, title: string }>, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }>, testExercises: Array<{ id: string, title: string, description: string }> }>, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> };

export type HomeworkScriptFragment = { id: string, title: string, practiceMilestone: { id: string, title: string, ratingType: ScriptRatingTypeEnum }, relatedScripts: Array<{ id: string, title: string }>, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }>, testExercises: Array<{ id: string, title: string, description: string }>, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null };

export type ParagraphFragment = { id: string, title: string, paragraphSections: Array<{ title: string, id: string, contents: Array<{ __typename: 'Image' } | { __typename: 'Text' } | { __typename: 'Video' }> }> };

export type RedeemRoadmapPaywallCodeMutationVariables = Exact<{
    input: RedeemRoadmapPaywallCodeInput;
}>;


export type RedeemRoadmapPaywallCodeMutation = { redeemRoadmapPaywallCode: boolean };

export type MilestoneProgressesQueryVariables = Exact<{
    input: MilestoneProgressesInput;
}>;


export type MilestoneProgressesQuery = { milestoneProgresses: Array<{ milestoneId: string, progress: number }> };

export type PracticeMilestoneQueryVariables = Exact<{
    input: PracticeMilestonesInput;
}>;


export type PracticeMilestoneQuery = { practiceMilestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, practiceMilestone: { id: string, title: string, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum }, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, relatedScripts: Array<{ id: string, title: string }>, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }>, testExercises: Array<{ id: string, title: string, description: string }> }>, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> };

export type RoadmapProgressesQueryVariables = Exact<{
    input?: InputMaybe<RoadmapProgressesInput>;
}>;


export type RoadmapProgressesQuery = { roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, hasPaywallAccess: boolean, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, practiceMilestone: { id: string, title: string, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum }, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, relatedScripts: Array<{ id: string, title: string }>, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }>, testExercises: Array<{ id: string, title: string, description: string }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, chapters: Array<{ id: string, paragraphs: Array<{ id: string, title: string, paragraphSections: Array<{ title: string, id: string, contents: Array<{ __typename: 'Image' } | { __typename: 'Text' } | { __typename: 'Video' }> }> }> }> }> } }> };

export type ScriptProgressesQueryVariables = Exact<{
    input: ScriptProgressesInput;
}>;


export type ScriptProgressesQuery = { scriptProgresses: Array<{ scriptId: string, progress: number, passed: boolean }> };

export type ScriptResultsQueryVariables = Exact<{
    input: ScriptResultsInput;
}>;


export type ScriptResultsQuery = { scriptResults: Array<{ id: string, rating: ScriptRatingEnum, script: { id: string, title: string, practiceMilestone: { id: string, title: string, ratingType: ScriptRatingTypeEnum } }, contextualScript?: { id: string, title: string } | null }> };

export type WorkInProgressQueryVariables = Exact<{
    input: WorkInProgressInput;
}>;


export type WorkInProgressQuery = { workInProgress: Array<{ id: string, title: string, practiceMilestone: { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, practiceMilestone: { id: string, title: string, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum }, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, relatedScripts: Array<{ id: string, title: string }>, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }>, testExercises: Array<{ id: string, title: string, description: string }> }>, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> } }> };

export type StudentFragment = { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> };

export type RoadmapProgressesFragment = { id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } };

export type StudentsPaginatorInfoFragment = { count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number };

export type AcceptInviteStudentToDrivingSchoolMutationVariables = Exact<{
    input: AcceptInviteStudentToDrivingSchoolInput;
}>;


export type AcceptInviteStudentToDrivingSchoolMutation = { acceptInviteStudentToDrivingSchool: { status: AcceptInviteStudentToDrivingSchoolStatusEnum } };

export type ConnectStudentToDrivingSchoolMutationVariables = Exact<{
    input: ConnectStudentToDrivingSchoolInput;
}>;


export type ConnectStudentToDrivingSchoolMutation = { connectStudentToDrivingSchool: { status: ConnectStudentToDrivingSchoolStatusEnum } };

export type CreateStudentMutationVariables = Exact<{
    input: CreateStudentInput;
}>;


export type CreateStudentMutation = { createStudent: { status: CreateStudentStatusEnum, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> } | null } };

export type InviteStudentToDrivingSchoolMutationVariables = Exact<{
    input: InviteStudentToDrivingSchoolInput;
}>;


export type InviteStudentToDrivingSchoolMutation = { inviteStudentToDrivingSchool: { status: InviteStudentToDrivingSchoolStatusEnum } };

export type UpdateStudentMutationVariables = Exact<{
    input: UpdateStudentInput;
}>;


export type UpdateStudentMutation = { updateStudent: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> } };

export type StudentsQueryVariables = Exact<{
    search?: InputMaybe<Scalars['String']>;
    page?: InputMaybe<Scalars['Int']>;
    first: Scalars['Int'];
    orderBy?: InputMaybe<Array<QueryStudentsOrderByOrderByClause> | QueryStudentsOrderByOrderByClause>;
}>;


export type StudentsQuery = { students: { paginatorInfo: { count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ id: string, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } }> } };

export type StudentQueryVariables = Exact<{
    input: StudentInput;
}>;


export type StudentQuery = { student: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null, cbrId?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, student?: { id: string, birthdate?: any | null, phone?: string | null, avatar?: string | null } | null, roles: Array<{ id: string, name: RoleEnum }> }, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, roadmapProgresses: Array<{ id: string, goal: GoalEnum, roadmap: { id: string, title: string, milestones: Array<{ id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, examType: ExamTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, ratingType: ScriptRatingTypeEnum, scripts: Array<{ id: string, title: string, video?: { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum } | null, practiceMilestone: { id: string, title: string, subTitle?: string | null, ratingType: ScriptRatingTypeEnum }, scriptSections: Array<{ id: string, title: string, header?: string | null, contents: Array<{ id: string, title: string, image: string, altText?: string | null } | { id: string, title: string, text: string } | { id: string, title: string, videoId: string, proxyUrl?: string | null, provider: VideoProviderEnum }> }> }> } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum, testType: TestTypeEnum } | { id: string, title: string, subTitle?: string | null, icon?: string | null, type: MilestoneTypeEnum }> } }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }> } };

export type AddressFragment = { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string };

export type ContactFragment = { id: string, firstName: string, lastName: string, email: string, phone?: string | null };

export type UserFragment = { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> };

export type DrivingSchoolFragment = { id: string, name: string, cbrId: string, connectCode: number, phone?: string | null, iban?: string | null, coc?: string | null, vat?: string | null, createdAt: any, updatedAt: any, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, visitAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, organization: { id: string, name: string, calendarEventTypes: Array<{ id: string, name: string }> }, vehicles: Array<{ id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any }> };

export type VerifyEmailMutationVariables = Exact<{
    input: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { verifyEmail: { status: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, avatar?: string | null, cbrId?: string | null, phone?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null, drivingSchools: Array<{ id: string, name: string, cbrId: string, connectCode: number, phone?: string | null, iban?: string | null, coc?: string | null, vat?: string | null, createdAt: any, updatedAt: any, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, visitAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, organization: { id: string, name: string, calendarEventTypes: Array<{ id: string, name: string }> }, vehicles: Array<{ id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any }> }> } | null, organizations: Array<{ name: string, id: string, createdAt: any, updatedAt: any, drivingSchools: Array<{ id: string, name: string, cbrId: string, connectCode: number, phone?: string | null, iban?: string | null, coc?: string | null, vat?: string | null, createdAt: any, updatedAt: any, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, visitAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, organization: { id: string, name: string, calendarEventTypes: Array<{ id: string, name: string }> }, vehicles: Array<{ id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any }> }> }>, drivingSchools: Array<{ id: string, name: string, cbrId: string, connectCode: number, phone?: string | null, iban?: string | null, coc?: string | null, vat?: string | null, createdAt: any, updatedAt: any, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, visitAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, organization: { id: string, name: string, calendarEventTypes: Array<{ id: string, name: string }> }, vehicles: Array<{ id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any }> }>, student?: { id: string, phone?: string | null, birthdate?: any | null, avatar?: string | null, cbrId?: string | null, drivingSchools: Array<{ id: string, name: string, cbrId: string, connectCode: number, phone?: string | null, iban?: string | null, coc?: string | null, vat?: string | null, createdAt: any, updatedAt: any, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, visitAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, organization: { id: string, name: string, calendarEventTypes: Array<{ id: string, name: string }> }, vehicles: Array<{ id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any }> }>, preferredInstructors: Array<{ id: string, cbrId?: string | null, phone?: string | null, avatar?: string | null, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, instructor?: { id: string, phone?: string | null, avatar?: string | null, preferredVehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } | null, roles: Array<{ id: string, name: RoleEnum }> } }>, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, user: { id: string, createdAt: any, updatedAt: any, email: string, firstName: string, lastName: string, roles: Array<{ id: string, name: RoleEnum }> } } | null, roles: Array<{ id: string, name: RoleEnum }> } };

export type VehiclePaginatorInfoFragment = { count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number };

export type MileagePaginatorInfoFragment = { count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number };

export type VehicleFragment = { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any };

export type CreateVehicleMutationVariables = Exact<{
    input: CreateVehicleInput;
}>;


export type CreateVehicleMutation = { createVehicle: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any, drivingSchool: { id: string, name: string, cbrId: string, connectCode: number, phone?: string | null, iban?: string | null, coc?: string | null, vat?: string | null, createdAt: any, updatedAt: any, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, visitAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, organization: { id: string, name: string, calendarEventTypes: Array<{ id: string, name: string }> }, vehicles: Array<{ id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any }> } } };

export type DeleteVehicleMutationVariables = Exact<{
    input: DeleteVehicleInput;
}>;


export type DeleteVehicleMutation = { deleteVehicle: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any, drivingSchool: { id: string, name: string, cbrId: string, connectCode: number, phone?: string | null, iban?: string | null, coc?: string | null, vat?: string | null, createdAt: any, updatedAt: any, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, visitAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, organization: { id: string, name: string, calendarEventTypes: Array<{ id: string, name: string }> }, vehicles: Array<{ id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any }> } } };

export type UpdateVehicleMutationVariables = Exact<{
    input: UpdateVehicleInput;
}>;


export type UpdateVehicleMutation = { updateVehicle: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any, drivingSchool: { id: string, name: string, cbrId: string, connectCode: number, phone?: string | null, iban?: string | null, coc?: string | null, vat?: string | null, createdAt: any, updatedAt: any, invoiceAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, pickupAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, postalAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, visitAddress?: { id: string, street: string, number: string, numberAddition?: string | null, postalCode: string, city: string } | null, contacts: Array<{ id: string, firstName: string, lastName: string, email: string, phone?: string | null }>, organization: { id: string, name: string, calendarEventTypes: Array<{ id: string, name: string }> }, vehicles: Array<{ id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any }> } } };

export type CreateMileageMutationVariables = Exact<{
    input: CreateMileageInput;
}>;


export type CreateMileageMutation = { createMileage: { id: string, kilometers: number, registeredAt: any, notes?: string | null, vehicle?: { id: string, cbrId?: string | null, name?: string | null, brand: string, model: string, licensePlate: string, year: number, updatedAt: any, createdAt: any } | null } };

export type DeleteMileageMutationVariables = Exact<{
    input: DeleteMileageInput;
}>;


export type DeleteMileageMutation = { deleteMileage: { id: string } };

export type VehiclesQueryVariables = Exact<{
    first: Scalars['Int'];
    search?: InputMaybe<Scalars['String']>;
    orderBy?: InputMaybe<Array<QueryVehiclesOrderByOrderByClause> | QueryVehiclesOrderByOrderByClause>;
    page?: InputMaybe<Scalars['Int']>;
}>;


export type VehiclesQuery = { vehicles: { paginatorInfo: { count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ id: string, name?: string | null, cbrId?: string | null, licensePlate: string, brand: string, model: string, year: number, drivingSchool: { id: string, name: string, cbrId: string, createdAt: any, updatedAt: any } }> } };

export type MileagesQueryVariables = Exact<{
    first: Scalars['Int'];
    vehicleId: Scalars['ID'];
    orderBy?: InputMaybe<Array<QueryMileagesOrderByOrderByClause> | QueryMileagesOrderByOrderByClause>;
    page?: InputMaybe<Scalars['Int']>;
}>;


export type MileagesQuery = { mileages: { paginatorInfo: { count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ id: string, kilometers: number, registeredAt: any, notes?: string | null, createdAt: any, updatedAt: any, vehicle?: { id: string, name?: string | null, cbrId?: string | null, licensePlate: string, brand: string, model: string, year: number, createdAt: any, updatedAt: any } | null }> } };

export const LoginFragmentDoc = gql`
    fragment Login on AuthPayload {
  accessToken
  expiresIn
  refreshToken
  tokenType
}
    `;
export const RefreshTokenFragmentDoc = gql`
    fragment RefreshToken on RefreshTokenPayload {
  accessToken
  expiresIn
  refreshToken
  tokenType
}
    `;
export const EducationCategoryFragmentDoc = gql`
    fragment EducationCategory on EducationCategory {
  id
  name
  icon
}
    `;
export const CourseProductFragmentDoc = gql`
    fragment CourseProduct on CourseProduct {
  id
  title
  priceExcludingVat
  color
  defaultDurationInMinutes
  educationCategory {
    ...EducationCategory
  }
  vatPercentage {
    id
    amount
  }
}
    ${EducationCategoryFragmentDoc}`;
export const DrivingLessonProductFragmentDoc = gql`
    fragment DrivingLessonProduct on DrivingLessonProduct {
  id
  title
  priceExcludingVat
  color
  defaultDurationInMinutes
  pricePerDurationInMinutes
  creditDisplayType
  allowsReservations
  educationCategory {
    ...EducationCategory
  }
  vatPercentage {
    id
    amount
  }
}
    ${EducationCategoryFragmentDoc}`;
export const ExamProductFragmentDoc = gql`
    fragment ExamProduct on ExamProduct {
  id
  title
  priceExcludingVat
  color
  defaultDurationInMinutes
  examType
  purchasePrice
  educationCategory {
    ...EducationCategory
  }
  vatPercentage {
    id
    amount
  }
}
    ${EducationCategoryFragmentDoc}`;
export const GenericProductFragmentDoc = gql`
    fragment GenericProduct on GenericProduct {
  id
  title
  priceExcludingVat
  educationCategory {
    ...EducationCategory
  }
  vatPercentage {
    id
    amount
  }
}
    ${EducationCategoryFragmentDoc}`;
export const InstructorPaginatorInfoFragmentDoc = gql`
    fragment InstructorPaginatorInfo on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  createdAt
  updatedAt
  email
  firstName
  lastName
  roles {
    id
    name
  }
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  id
  street
  number
  numberAddition
  postalCode
  city
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on Contact {
  id
  firstName
  lastName
  email
  phone
}
    `;
export const VideoFragmentDoc = gql`
    fragment Video on Video {
  id
  title
  videoId
  proxyUrl
  provider
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on Image {
  id
  title
  image
  altText
}
    `;
export const TextFragmentDoc = gql`
    fragment Text on Text {
  id
  title
  text
}
    `;
export const ScriptSectionFragmentDoc = gql`
    fragment ScriptSection on ScriptSection {
  id
  title
  header
  contents {
    ... on Image {
      ...Image
    }
    ... on Text {
      ...Text
    }
    ... on Video {
      ...Video
    }
  }
}
    ${ImageFragmentDoc}
${TextFragmentDoc}
${VideoFragmentDoc}`;
export const RoadmapProgressesFragmentDoc = gql`
    fragment RoadmapProgresses on RoadmapProgress {
  id
  goal
  roadmap {
    id
    title
    milestones {
      ... on ExamMilestone {
        id
        title
        subTitle
        icon
        type
        examType
      }
      ... on PracticeMilestone {
        id
        title
        subTitle
        icon
        type
        ratingType
        scripts {
          id
          title
          video {
            ...Video
          }
          practiceMilestone {
            id
            title
            subTitle
            ratingType
          }
          scriptSections {
            ...ScriptSection
          }
        }
      }
      ... on ReviewMilestone {
        id
        title
        subTitle
        icon
        type
      }
      ... on TestMilestone {
        id
        title
        subTitle
        icon
        type
        testType
      }
      ... on TheoryMilestone {
        id
        title
        subTitle
        icon
        type
      }
    }
  }
}
    ${VideoFragmentDoc}
${ScriptSectionFragmentDoc}`;
export const VehicleFragmentDoc = gql`
    fragment Vehicle on Vehicle {
  id
  cbrId
  name
  brand
  model
  licensePlate
  year
  updatedAt
  createdAt
}
    `;
export const InstructorFragmentDoc = gql`
    fragment Instructor on Instructor {
  id
  cbrId
  phone
  avatar
  user {
    ...User
    instructor {
      id
      phone
      avatar
      preferredVehicle {
        ...Vehicle
      }
    }
  }
}
    ${UserFragmentDoc}
${VehicleFragmentDoc}`;
export const StudentFragmentDoc = gql`
    fragment Student on Student {
  id
  birthdate
  phone
  avatar
  cbrId
  user {
    ...User
    student {
      id
      birthdate
      phone
      avatar
    }
    roles {
      id
      name
    }
  }
  pickupAddress {
    ...Address
  }
  postalAddress {
    ...Address
  }
  invoiceAddress {
    ...Address
  }
  contacts {
    ...Contact
  }
  roadmapProgresses {
    ...RoadmapProgresses
  }
  preferredInstructors {
    ...Instructor
  }
}
    ${UserFragmentDoc}
${AddressFragmentDoc}
${ContactFragmentDoc}
${RoadmapProgressesFragmentDoc}
${InstructorFragmentDoc}`;
export const StudentNoteFragmentDoc = gql`
    fragment StudentNote on StudentNote {
  id
  text
  createdAt
  updatedAt
  student {
    ...Student
  }
  author {
    id
    firstName
    lastName
    email
    roles {
      id
      name
    }
  }
}
    ${StudentFragmentDoc}`;
export const ScriptNoteFragmentDoc = gql`
    fragment ScriptNote on ScriptNote {
  id
  text
  visibleForStudent
  createdAt
  updatedAt
  script {
    title
    id
  }
  roadmapProgress {
    id
    goal
    roadmap {
      title
    }
  }
  author {
    id
    firstName
    email
    lastName
    roles {
      id
      name
    }
  }
}
    `;
export const EventFragmentDoc = gql`
    fragment Event on CalendarEvent {
  id
  type {
    id
    name
  }
  status
  title
  description
  startsAt
  endsAt
  location
  tableNumber
}
    `;
export const CalendarEventNoteFragmentDoc = gql`
    fragment CalendarEventNote on CalendarEventNote {
  id
  text
  visibleForStudent
  createdAt
  updatedAt
  calendarEvent {
    ...Event
  }
  author {
    id
    firstName
    email
    lastName
    roles {
      id
      name
    }
  }
}
    ${EventFragmentDoc}`;
export const TestExerciseFragmentDoc = gql`
    fragment TestExercise on TestExercise {
  id
  title
  description
}
    `;
export const PracticeMilestoneScriptFragmentDoc = gql`
    fragment PracticeMilestoneScript on Script {
  id
  title
  practiceMilestone {
    id
    title
    type
    ratingType
  }
  video {
    ...Video
  }
  relatedScripts {
    id
    title
  }
  scriptSections {
    ...ScriptSection
  }
  testExercises {
    ...TestExercise
  }
}
    ${VideoFragmentDoc}
${ScriptSectionFragmentDoc}
${TestExerciseFragmentDoc}`;
export const PracticeMileStoneFragmentDoc = gql`
    fragment PracticeMileStone on PracticeMilestone {
  id
  title
  subTitle
  icon
  type
  ratingType
  scripts {
    ...PracticeMilestoneScript
  }
  contents {
    ... on Image {
      ...Image
    }
    ... on Text {
      ...Text
    }
    ... on Video {
      ...Video
    }
  }
}
    ${PracticeMilestoneScriptFragmentDoc}
${ImageFragmentDoc}
${TextFragmentDoc}
${VideoFragmentDoc}`;
export const WorkInProgressScriptFragmentDoc = gql`
    fragment WorkInProgressScript on Script {
  id
  title
  practiceMilestone {
    ...PracticeMileStone
  }
}
    ${PracticeMileStoneFragmentDoc}`;
export const HomeworkScriptFragmentDoc = gql`
    fragment HomeworkScript on Script {
  id
  title
  practiceMilestone {
    id
    title
    ratingType
  }
  relatedScripts {
    id
    title
  }
  scriptSections {
    ...ScriptSection
  }
  testExercises {
    id
    title
    description
  }
  video {
    ...Video
  }
}
    ${ScriptSectionFragmentDoc}
${VideoFragmentDoc}`;
export const ParagraphFragmentDoc = gql`
    fragment Paragraph on Paragraph {
  id
  title
  paragraphSections {
    title
    id
    contents {
      __typename
    }
  }
}
    `;
export const StudentsPaginatorInfoFragmentDoc = gql`
    fragment StudentsPaginatorInfo on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `;
export const DrivingSchoolFragmentDoc = gql`
    fragment DrivingSchool on DrivingSchool {
  id
  name
  cbrId
  connectCode
  phone
  iban
  coc
  vat
  createdAt
  updatedAt
  invoiceAddress {
    ...Address
  }
  pickupAddress {
    ...Address
  }
  postalAddress {
    ...Address
  }
  visitAddress {
    ...Address
  }
  contacts {
    ...Contact
  }
  organization {
    id
    name
    calendarEventTypes {
      id
      name
    }
  }
  vehicles {
    ...Vehicle
  }
}
    ${AddressFragmentDoc}
${ContactFragmentDoc}
${VehicleFragmentDoc}`;
export const VehiclePaginatorInfoFragmentDoc = gql`
    fragment VehiclePaginatorInfo on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `;
export const MileagePaginatorInfoFragmentDoc = gql`
    fragment MileagePaginatorInfo on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `;
export const UpdateCheckDocument = gql`
    query UpdateCheck($input: UpdateCheckInput!) {
  updateCheck(input: $input) {
    available
    promptMessage
    promptConfirmButtonLabel
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class UpdateCheckQueryService extends Apollo.Query<UpdateCheckQuery, UpdateCheckQueryVariables> {
    override document = UpdateCheckDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    ...Login
  }
}
    ${LoginFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class LoginMutationService extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    override document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    status
    message
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class LogoutMutationService extends Apollo.Mutation<LogoutMutation, LogoutMutationVariables> {
    override document = LogoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input) {
    message
    status
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class ForgotPasswordMutationService extends Apollo.Mutation<ForgotPasswordMutation, ForgotPasswordMutationVariables> {
    override document = ForgotPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: NewPasswordWithCodeInput) {
  resetPassword(input: $input) {
    message
    status
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class ResetPasswordMutationService extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    override document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const RefreshTokenDocument = gql`
    mutation RefreshToken($input: RefreshTokenInput) {
  refreshToken(input: $input) {
    ...RefreshToken
  }
}
    ${RefreshTokenFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class RefreshTokenMutationService extends Apollo.Mutation<RefreshTokenMutation, RefreshTokenMutationVariables> {
    override document = RefreshTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const RegisterStudentDocument = gql`
    mutation RegisterStudent($input: RegisterStudentInput!) {
  registerStudent(input: $input) {
    registerResponse {
      status
    }
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class RegisterStudentMutationService extends Apollo.Mutation<RegisterStudentMutation, RegisterStudentMutationVariables> {
    override document = RegisterStudentDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const ResendEmailVerificationLinkDocument = gql`
    mutation ResendEmailVerificationLink {
  resendEmailVerificationLink
}
    `;

@Injectable({
    providedIn: 'root',
})
export class ResendEmailVerificationLinkMutationService extends Apollo.Mutation<ResendEmailVerificationLinkMutation, ResendEmailVerificationLinkMutationVariables> {
    override document = ResendEmailVerificationLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CreateCalendarEventDocument = gql`
    mutation CreateCalendarEvent($input: CreateCalendarEventInput!) {
  createCalendarEvent(input: $input) {
    ...Event
  }
}
    ${EventFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class CreateCalendarEventMutationService extends Apollo.Mutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables> {
    override document = CreateCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const UpdateCalendarEventDocument = gql`
    mutation UpdateCalendarEvent($input: UpdateCalendarEventInput!) {
  updateCalendarEvent(input: $input) {
    ...Event
  }
}
    ${EventFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class UpdateCalendarEventMutationService extends Apollo.Mutation<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables> {
    override document = UpdateCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CalendarEventsDocument = gql`
    query CalendarEvents($input: CalendarEventsInput!) {
  calendarEvents(input: $input) {
    ...Event
    product {
      ... on CourseProduct {
        ...CourseProduct
        type
      }
      ... on DrivingLessonProduct {
        ...DrivingLessonProduct
        type
      }
      ... on ExamProduct {
        ...ExamProduct
        type
      }
      ... on GenericProduct {
        ...GenericProduct
        type
      }
    }
    calendarEventParticipants {
      id
      calendarEvent {
        ...Event
      }
      actor {
        ... on User {
          ...User
        }
        ... on Instructor {
          ...Instructor
        }
        ... on Student {
          ...Student
        }
      }
    }
  }
}
    ${EventFragmentDoc}
${CourseProductFragmentDoc}
${DrivingLessonProductFragmentDoc}
${ExamProductFragmentDoc}
${GenericProductFragmentDoc}
${UserFragmentDoc}
${InstructorFragmentDoc}
${StudentFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class CalendarEventsQueryService extends Apollo.Query<CalendarEventsQuery, CalendarEventsQueryVariables> {
    override document = CalendarEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CalendarEventDocument = gql`
    query CalendarEvent($input: CalendarEventInput!) {
  calendarEvent(input: $input) {
    ...Event
    drivingSchool {
      ...DrivingSchool
    }
    author {
      id
      firstName
      lastName
    }
    recurredFromEvent {
      ...Event
    }
    recurrences {
      ...Event
    }
    product {
      ... on CourseProduct {
        ...CourseProduct
        type
      }
      ... on DrivingLessonProduct {
        ...DrivingLessonProduct
        type
      }
      ... on ExamProduct {
        ...ExamProduct
        type
      }
      ... on GenericProduct {
        ...GenericProduct
        type
      }
    }
    calendarEventParticipants {
      id
      calendarEvent {
        ...Event
      }
      actor {
        ... on User {
          ...User
        }
        ... on Instructor {
          ...Instructor
        }
        ... on Student {
          ...Student
        }
      }
    }
    vehicles {
      ...Vehicle
    }
  }
}
    ${EventFragmentDoc}
${DrivingSchoolFragmentDoc}
${CourseProductFragmentDoc}
${DrivingLessonProductFragmentDoc}
${ExamProductFragmentDoc}
${GenericProductFragmentDoc}
${UserFragmentDoc}
${InstructorFragmentDoc}
${StudentFragmentDoc}
${VehicleFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class CalendarEventQueryService extends Apollo.Query<CalendarEventQuery, CalendarEventQueryVariables> {
    override document = CalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const EducationCategoriesDocument = gql`
    query EducationCategories($input: EducationCategoriesInput) {
  educationCategories(input: $input) {
    id
    name
    icon
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class EducationCategoriesQueryService extends Apollo.Query<EducationCategoriesQuery, EducationCategoriesQueryVariables> {
    override document = EducationCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CreateScriptResultDocument = gql`
    mutation CreateScriptResult($input: CreateScriptResultInput!) {
  createScriptResult(input: $input) {
    script {
      id
    }
    contextualScript {
      id
    }
    rating
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class CreateScriptResultMutationService extends Apollo.Mutation<CreateScriptResultMutation, CreateScriptResultMutationVariables> {
    override document = CreateScriptResultDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const EligibleForHomeworkDocument = gql`
    query EligibleForHomework($input: EligibleForHomeworkInput!) {
  eligibleForHomework(input: $input) {
    id
    title
    practiceMilestone {
      id
      title
      ratingType
    }
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class EligibleForHomeworkQueryService extends Apollo.Query<EligibleForHomeworkQuery, EligibleForHomeworkQueryVariables> {
    override document = EligibleForHomeworkDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const HomeworkDocument = gql`
    query Homework($input: HomeworkInput!) {
  homework(input: $input) {
    ...HomeworkScript
  }
}
    ${HomeworkScriptFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class HomeworkQueryService extends Apollo.Query<HomeworkQuery, HomeworkQueryVariables> {
    override document = HomeworkDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const UsedRelatedScriptsDocument = gql`
    query UsedRelatedScripts($input: UsedRelatedScriptsInput!) {
  usedRelatedScripts(input: $input) {
    id
    title
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class UsedRelatedScriptsQueryService extends Apollo.Query<UsedRelatedScriptsQuery, UsedRelatedScriptsQueryVariables> {
    override document = UsedRelatedScriptsDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const InstructorsDocument = gql`
    query Instructors($first: Int!, $page: Int, $orderBy: [QueryInstructorsOrderByOrderByClause!], $search: String) {
  instructors(first: $first, page: $page, orderBy: $orderBy, search: $search) {
    paginatorInfo {
      ...InstructorPaginatorInfo
    }
    data {
      ...Instructor
    }
  }
}
    ${InstructorPaginatorInfoFragmentDoc}
${InstructorFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class InstructorsQueryService extends Apollo.Query<InstructorsQuery, InstructorsQueryVariables> {
    override document = InstructorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const InstructorDocument = gql`
    query Instructor($input: InstructorInput!) {
  instructor(input: $input) {
    ...Instructor
  }
}
    ${InstructorFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class InstructorQueryService extends Apollo.Query<InstructorQuery, InstructorQueryVariables> {
    override document = InstructorDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const DeleteStudentNoteDocument = gql`
    mutation DeleteStudentNote($input: DeleteStudentNoteInput!) {
  deleteStudentNote(input: $input) {
    ...StudentNote
  }
}
    ${StudentNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class DeleteStudentNoteMutationService extends Apollo.Mutation<DeleteStudentNoteMutation, DeleteStudentNoteMutationVariables> {
    override document = DeleteStudentNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const UpdateStudentNoteDocument = gql`
    mutation UpdateStudentNote($input: UpdateStudentNoteInput!) {
  updateStudentNote(input: $input) {
    ...StudentNote
  }
}
    ${StudentNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class UpdateStudentNoteMutationService extends Apollo.Mutation<UpdateStudentNoteMutation, UpdateStudentNoteMutationVariables> {
    override document = UpdateStudentNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CreateStudentNoteDocument = gql`
    mutation CreateStudentNote($input: CreateStudentNoteInput!) {
  createStudentNote(input: $input) {
    ...StudentNote
  }
}
    ${StudentNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class CreateStudentNoteMutationService extends Apollo.Mutation<CreateStudentNoteMutation, CreateStudentNoteMutationVariables> {
    override document = CreateStudentNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CreateScriptNoteDocument = gql`
    mutation CreateScriptNote($input: CreateScriptNoteInput!) {
  createScriptNote(input: $input) {
    ...ScriptNote
  }
}
    ${ScriptNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class CreateScriptNoteMutationService extends Apollo.Mutation<CreateScriptNoteMutation, CreateScriptNoteMutationVariables> {
    override document = CreateScriptNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const DeleteScriptNoteDocument = gql`
    mutation DeleteScriptNote($input: DeleteScriptNoteInput!) {
  deleteScriptNote(input: $input) {
    ...ScriptNote
  }
}
    ${ScriptNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class DeleteScriptNoteMutationService extends Apollo.Mutation<DeleteScriptNoteMutation, DeleteScriptNoteMutationVariables> {
    override document = DeleteScriptNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const UpdateScriptNoteDocument = gql`
    mutation UpdateScriptNote($input: UpdateScriptNoteInput!) {
  updateScriptNote(input: $input) {
    ...ScriptNote
  }
}
    ${ScriptNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class UpdateScriptNoteMutationService extends Apollo.Mutation<UpdateScriptNoteMutation, UpdateScriptNoteMutationVariables> {
    override document = UpdateScriptNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CreateCalendarEventNoteDocument = gql`
    mutation CreateCalendarEventNote($input: CreateCalendarEventNoteInput!) {
  createCalendarEventNote(input: $input) {
    ...CalendarEventNote
  }
}
    ${CalendarEventNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class CreateCalendarEventNoteMutationService extends Apollo.Mutation<CreateCalendarEventNoteMutation, CreateCalendarEventNoteMutationVariables> {
    override document = CreateCalendarEventNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const DeleteCalendarEventNoteDocument = gql`
    mutation DeleteCalendarEventNote($input: DeleteCalendarEventNoteInput!) {
  deleteCalendarEventNote(input: $input) {
    ...CalendarEventNote
  }
}
    ${CalendarEventNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class DeleteCalendarEventNoteMutationService extends Apollo.Mutation<DeleteCalendarEventNoteMutation, DeleteCalendarEventNoteMutationVariables> {
    override document = DeleteCalendarEventNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const UpdateCalendarEventNoteDocument = gql`
    mutation UpdateCalendarEventNote($input: UpdateCalendarEventNoteInput!) {
  updateCalendarEventNote(input: $input) {
    ...CalendarEventNote
  }
}
    ${CalendarEventNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class UpdateCalendarEventNoteMutationService extends Apollo.Mutation<UpdateCalendarEventNoteMutation, UpdateCalendarEventNoteMutationVariables> {
    override document = UpdateCalendarEventNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const StudentNotesDocument = gql`
    query StudentNotes($input: StudentNotesInput!, $orderBy: [QueryStudentNotesOrderByOrderByClause!]) {
  studentNotes(input: $input, orderBy: $orderBy) {
    ...StudentNote
  }
}
    ${StudentNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class StudentNotesQueryService extends Apollo.Query<StudentNotesQuery, StudentNotesQueryVariables> {
    override document = StudentNotesDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const ScriptNotesDocument = gql`
    query ScriptNotes($input: ScriptNotesInput!, $orderBy: [QueryScriptNotesOrderByOrderByClause!]) {
  scriptNotes(input: $input, orderBy: $orderBy) {
    ...ScriptNote
  }
}
    ${ScriptNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class ScriptNotesQueryService extends Apollo.Query<ScriptNotesQuery, ScriptNotesQueryVariables> {
    override document = ScriptNotesDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CalendarEventNotesDocument = gql`
    query CalendarEventNotes($input: CalendarEventNotesInput!, $orderBy: [QueryCalendarEventNotesOrderByOrderByClause!]) {
  calendarEventNotes(input: $input, orderBy: $orderBy) {
    ...CalendarEventNote
  }
}
    ${CalendarEventNoteFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class CalendarEventNotesQueryService extends Apollo.Query<CalendarEventNotesQuery, CalendarEventNotesQueryVariables> {
    override document = CalendarEventNotesDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const PackagesDocument = gql`
    query Packages($input: PackagesInput!) {
  packages(input: $input) {
    id
    title
    drivingSchool {
      id
      name
      cbrId
      connectCode
      organization {
        id
        name
      }
    }
    packageProducts {
      id
      quantity
      unitPriceExcludingVat
      package {
        id
        title
      }
    }
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class PackagesQueryService extends Apollo.Query<PackagesQuery, PackagesQueryVariables> {
    override document = PackagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const ProductsDocument = gql`
    query Products($input: ProductsInput!) {
  products(input: $input) {
    ... on CourseProduct {
      id
      type
      title
      priceExcludingVat
      color
      defaultDurationInMinutes
      educationCategory {
        id
        name
        icon
      }
      vatPercentage {
        id
        amount
      }
    }
    ... on DrivingLessonProduct {
      id
      type
      title
      priceExcludingVat
      color
      defaultDurationInMinutes
      pricePerDurationInMinutes
      creditDisplayType
      allowsReservations
      educationCategory {
        id
        name
        icon
      }
      vatPercentage {
        id
        amount
      }
    }
    ... on ExamProduct {
      id
      type
      title
      priceExcludingVat
      color
      defaultDurationInMinutes
      examType
      purchasePrice
      educationCategory {
        id
        name
        icon
      }
      vatPercentage {
        id
        amount
      }
    }
    ... on GenericProduct {
      id
      type
      title
      priceExcludingVat
      educationCategory {
        id
        name
        icon
      }
      vatPercentage {
        id
        amount
      }
    }
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class ProductsQueryService extends Apollo.Query<ProductsQuery, ProductsQueryVariables> {
    override document = ProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const RedeemRoadmapPaywallCodeDocument = gql`
    mutation RedeemRoadmapPaywallCode($input: RedeemRoadmapPaywallCodeInput!) {
  redeemRoadmapPaywallCode(input: $input)
}
    `;

@Injectable({
    providedIn: 'root',
})
export class RedeemRoadmapPaywallCodeMutationService extends Apollo.Mutation<RedeemRoadmapPaywallCodeMutation, RedeemRoadmapPaywallCodeMutationVariables> {
    override document = RedeemRoadmapPaywallCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const MilestoneProgressesDocument = gql`
    query MilestoneProgresses($input: MilestoneProgressesInput!) {
  milestoneProgresses(input: $input) {
    milestoneId
    progress
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class MilestoneProgressesQueryService extends Apollo.Query<MilestoneProgressesQuery, MilestoneProgressesQueryVariables> {
    override document = MilestoneProgressesDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const PracticeMilestoneDocument = gql`
    query PracticeMilestone($input: PracticeMilestonesInput!) {
  practiceMilestones(input: $input) {
    ...PracticeMileStone
  }
}
    ${PracticeMileStoneFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class PracticeMilestoneQueryService extends Apollo.Query<PracticeMilestoneQuery, PracticeMilestoneQueryVariables> {
    override document = PracticeMilestoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const RoadmapProgressesDocument = gql`
    query RoadmapProgresses($input: RoadmapProgressesInput) {
  roadmapProgresses(input: $input) {
    id
    goal
    roadmap {
      id
      title
      hasPaywallAccess
      milestones {
        ... on ExamMilestone {
          id
          title
          subTitle
          icon
          type
          examType
        }
        ... on PracticeMilestone {
          id
          title
          subTitle
          icon
          type
          ratingType
          scripts {
            ...PracticeMilestoneScript
          }
        }
        ... on ReviewMilestone {
          id
          title
          subTitle
          icon
          type
        }
        ... on TestMilestone {
          id
          title
          subTitle
          icon
          type
          testType
        }
        ... on TheoryMilestone {
          id
          title
          subTitle
          icon
          type
          chapters {
            id
            paragraphs {
              ... on Paragraph {
                ...Paragraph
              }
            }
          }
        }
      }
    }
  }
}
    ${PracticeMilestoneScriptFragmentDoc}
${ParagraphFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class RoadmapProgressesQueryService extends Apollo.Query<RoadmapProgressesQuery, RoadmapProgressesQueryVariables> {
    override document = RoadmapProgressesDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const ScriptProgressesDocument = gql`
    query ScriptProgresses($input: ScriptProgressesInput!) {
  scriptProgresses(input: $input) {
    scriptId
    progress
    passed
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class ScriptProgressesQueryService extends Apollo.Query<ScriptProgressesQuery, ScriptProgressesQueryVariables> {
    override document = ScriptProgressesDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const ScriptResultsDocument = gql`
    query ScriptResults($input: ScriptResultsInput!) {
  scriptResults(input: $input) {
    id
    rating
    script {
      id
      title
      practiceMilestone {
        id
        title
        ratingType
      }
    }
    contextualScript {
      id
      title
    }
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class ScriptResultsQueryService extends Apollo.Query<ScriptResultsQuery, ScriptResultsQueryVariables> {
    override document = ScriptResultsDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const WorkInProgressDocument = gql`
    query WorkInProgress($input: WorkInProgressInput!) {
  workInProgress(input: $input) {
    ...WorkInProgressScript
  }
}
    ${WorkInProgressScriptFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class WorkInProgressQueryService extends Apollo.Query<WorkInProgressQuery, WorkInProgressQueryVariables> {
    override document = WorkInProgressDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const AcceptInviteStudentToDrivingSchoolDocument = gql`
    mutation AcceptInviteStudentToDrivingSchool($input: AcceptInviteStudentToDrivingSchoolInput!) {
  acceptInviteStudentToDrivingSchool(input: $input) {
    status
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class AcceptInviteStudentToDrivingSchoolMutationService extends Apollo.Mutation<AcceptInviteStudentToDrivingSchoolMutation, AcceptInviteStudentToDrivingSchoolMutationVariables> {
    override document = AcceptInviteStudentToDrivingSchoolDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const ConnectStudentToDrivingSchoolDocument = gql`
    mutation ConnectStudentToDrivingSchool($input: ConnectStudentToDrivingSchoolInput!) {
  connectStudentToDrivingSchool(input: $input) {
    status
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class ConnectStudentToDrivingSchoolMutationService extends Apollo.Mutation<ConnectStudentToDrivingSchoolMutation, ConnectStudentToDrivingSchoolMutationVariables> {
    override document = ConnectStudentToDrivingSchoolDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CreateStudentDocument = gql`
    mutation CreateStudent($input: CreateStudentInput!) {
  createStudent(input: $input) {
    status
    student {
      ...Student
    }
  }
}
    ${StudentFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class CreateStudentMutationService extends Apollo.Mutation<CreateStudentMutation, CreateStudentMutationVariables> {
    override document = CreateStudentDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const InviteStudentToDrivingSchoolDocument = gql`
    mutation InviteStudentToDrivingSchool($input: InviteStudentToDrivingSchoolInput!) {
  inviteStudentToDrivingSchool(input: $input) {
    status
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class InviteStudentToDrivingSchoolMutationService extends Apollo.Mutation<InviteStudentToDrivingSchoolMutation, InviteStudentToDrivingSchoolMutationVariables> {
    override document = InviteStudentToDrivingSchoolDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const UpdateStudentDocument = gql`
    mutation UpdateStudent($input: UpdateStudentInput!) {
  updateStudent(input: $input) {
    ...Student
  }
}
    ${StudentFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class UpdateStudentMutationService extends Apollo.Mutation<UpdateStudentMutation, UpdateStudentMutationVariables> {
    override document = UpdateStudentDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const StudentsDocument = gql`
    query Students($search: String, $page: Int, $first: Int!, $orderBy: [QueryStudentsOrderByOrderByClause!]) {
  students(search: $search, page: $page, first: $first, orderBy: $orderBy) {
    paginatorInfo {
      ...StudentsPaginatorInfo
    }
    data {
      id
      avatar
      user {
        ...User
      }
    }
  }
}
    ${StudentsPaginatorInfoFragmentDoc}
${UserFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class StudentsQueryService extends Apollo.Query<StudentsQuery, StudentsQueryVariables> {
    override document = StudentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const StudentDocument = gql`
    query Student($input: StudentInput!) {
  student(input: $input) {
    ...Student
  }
}
    ${StudentFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class StudentQueryService extends Apollo.Query<StudentQuery, StudentQueryVariables> {
    override document = StudentDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($input: VerifyEmailInput!) {
  verifyEmail(input: $input) {
    status
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class VerifyEmailMutationService extends Apollo.Mutation<VerifyEmailMutation, VerifyEmailMutationVariables> {
    override document = VerifyEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const MeDocument = gql`
    query Me {
  me {
    ...User
    instructor {
      id
      avatar
      cbrId
      phone
      preferredVehicle {
        ...Vehicle
      }
      drivingSchools {
        ...DrivingSchool
      }
    }
    organizations {
      name
      id
      createdAt
      updatedAt
      drivingSchools {
        ...DrivingSchool
      }
    }
    drivingSchools {
      ...DrivingSchool
    }
    student {
      id
      phone
      birthdate
      avatar
      cbrId
      phone
      drivingSchools {
        ...DrivingSchool
      }
      preferredInstructors {
        ...Instructor
      }
      invoiceAddress {
        ...Address
      }
      pickupAddress {
        ...Address
      }
      postalAddress {
        ...Address
      }
      contacts {
        ...Contact
      }
      user {
        ...User
      }
    }
  }
}
    ${UserFragmentDoc}
${VehicleFragmentDoc}
${DrivingSchoolFragmentDoc}
${InstructorFragmentDoc}
${AddressFragmentDoc}
${ContactFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class MeQueryService extends Apollo.Query<MeQuery, MeQueryVariables> {
    override document = MeDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CreateVehicleDocument = gql`
    mutation CreateVehicle($input: CreateVehicleInput!) {
  createVehicle(input: $input) {
    ...Vehicle
    drivingSchool {
      ...DrivingSchool
    }
  }
}
    ${VehicleFragmentDoc}
${DrivingSchoolFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class CreateVehicleMutationService extends Apollo.Mutation<CreateVehicleMutation, CreateVehicleMutationVariables> {
    override document = CreateVehicleDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const DeleteVehicleDocument = gql`
    mutation DeleteVehicle($input: DeleteVehicleInput!) {
  deleteVehicle(input: $input) {
    ...Vehicle
    drivingSchool {
      ...DrivingSchool
    }
  }
}
    ${VehicleFragmentDoc}
${DrivingSchoolFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class DeleteVehicleMutationService extends Apollo.Mutation<DeleteVehicleMutation, DeleteVehicleMutationVariables> {
    override document = DeleteVehicleDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const UpdateVehicleDocument = gql`
    mutation UpdateVehicle($input: UpdateVehicleInput!) {
  updateVehicle(input: $input) {
    ...Vehicle
    drivingSchool {
      ...DrivingSchool
    }
  }
}
    ${VehicleFragmentDoc}
${DrivingSchoolFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class UpdateVehicleMutationService extends Apollo.Mutation<UpdateVehicleMutation, UpdateVehicleMutationVariables> {
    override document = UpdateVehicleDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const CreateMileageDocument = gql`
    mutation CreateMileage($input: CreateMileageInput!) {
  createMileage(input: $input) {
    id
    kilometers
    registeredAt
    notes
    vehicle {
      ...Vehicle
    }
  }
}
    ${VehicleFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class CreateMileageMutationService extends Apollo.Mutation<CreateMileageMutation, CreateMileageMutationVariables> {
    override document = CreateMileageDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const DeleteMileageDocument = gql`
    mutation DeleteMileage($input: DeleteMileageInput!) {
  deleteMileage(input: $input) {
    id
  }
}
    `;

@Injectable({
    providedIn: 'root',
})
export class DeleteMileageMutationService extends Apollo.Mutation<DeleteMileageMutation, DeleteMileageMutationVariables> {
    override document = DeleteMileageDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const VehiclesDocument = gql`
    query Vehicles($first: Int!, $search: String, $orderBy: [QueryVehiclesOrderByOrderByClause!], $page: Int) {
  vehicles(first: $first, search: $search, orderBy: $orderBy, page: $page) {
    paginatorInfo {
      ...VehiclePaginatorInfo
    }
    data {
      id
      name
      cbrId
      licensePlate
      brand
      model
      year
      drivingSchool {
        id
        name
        cbrId
        createdAt
        updatedAt
      }
    }
  }
}
    ${VehiclePaginatorInfoFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class VehiclesQueryService extends Apollo.Query<VehiclesQuery, VehiclesQueryVariables> {
    override document = VehiclesDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
export const MileagesDocument = gql`
    query Mileages($first: Int!, $vehicleId: ID!, $orderBy: [QueryMileagesOrderByOrderByClause!], $page: Int) {
  mileages(first: $first, vehicleId: $vehicleId, orderBy: $orderBy, page: $page) {
    paginatorInfo {
      ...MileagePaginatorInfo
    }
    data {
      id
      kilometers
      registeredAt
      notes
      vehicle {
        id
        name
        cbrId
        licensePlate
        brand
        model
        year
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
}
    ${MileagePaginatorInfoFragmentDoc}`;

@Injectable({
    providedIn: 'root',
})
export class MileagesQueryService extends Apollo.Query<MileagesQuery, MileagesQueryVariables> {
    override document = MileagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}